import { ThreePoint } from "./correctedAgeUtils";

export interface DataPoint {
    x: number;
    l?: number;
    m?: number;
    s?: number;
    y1?: number;
    y2?: number;
    y3?: number;
    y4?: number;
    y5?: number;
    y6?: number;
    y7?: number;
    y8?: number;
    y9?: number;
  }
   
  export const boysLengthData: DataPoint[] = [
    {x: 24, y1: 26.29, y2: 27.73, y3: 30.79, y4: 33.855, y5: 35.29},
    {x: 25, y1: 27.665, y2: 29.115, y3: 32.22, y4: 35.325, y5: 36.78},
    {x: 26, y1: 29.06, y2: 30.525, y3: 33.665, y4: 36.8, y5: 38.27},
    {x: 27, y1: 30.5, y2: 31.98, y3: 35.145, y4: 38.31, y5: 39.79},
    {x: 28, y1: 31.95, y2: 33.44, y3: 36.625, y4: 39.81, y5: 41.305},
    {x: 29, y1: 33.395, y2: 34.89, y3: 38.085, y4: 41.28, y5: 42.775},
    {x: 30, y1: 34.83, y2: 36.325, y3: 39.525, y4: 42.73, y5: 44.225},
    {x: 31, y1: 36.235, y2: 37.73, y3: 40.93, y4: 44.125, y5: 45.62},
    {x: 32, y1: 37.61, y2: 39.1, y3: 42.28, y4: 45.465, y5: 46.95},
    {x: 33, y1: 38.955, y2: 40.43, y3: 43.595, y4: 46.76, y5: 48.24},
    {x: 34, y1: 40.265, y2: 41.735, y3: 44.875, y4: 48.015, y5: 49.485},
    {x: 35, y1: 41.505, y2: 42.96, y3: 46.07, y4: 49.185, y5: 50.64},
    {x: 36, y1: 42.69, y2: 44.13, y3: 47.21, y4: 50.285, y5: 51.725},
    {x: 37, y1: 43.795, y2: 45.215, y3: 48.255, y4: 51.295, y5: 52.72},
    {x: 38, y1: 44.8, y2: 46.205, y3: 49.205, y4: 52.205, y5: 53.605},
    {x: 39, y1: 45.77, y2: 47.155, y3: 50.115, y4: 53.08, y5: 54.46},
    {x: 40, y1: 46.715, y2: 48.08, y3: 51.005, y4: 53.925, y5: 55.29},
    {x: 41, y1: 47.63, y2: 48.98, y3: 51.87, y4: 54.755, y5: 56.105},
    {x: 42, y1: 48.53, y2: 49.86, y3: 52.715, y4: 55.565, y5: 56.9},
    {x: 43, y1: 49.41, y2: 50.73, y3: 53.545, y4: 56.36, y5: 57.68},
    {x: 44, y1: 50.27, y2: 51.57, y3: 54.36, y4: 57.145, y5: 58.45},
    {x: 45, y1: 51.13, y2: 52.42, y3: 55.18, y4: 57.935, y5: 59.225},
    {x: 46, y1: 52.02, y2: 53.295, y3: 56.025, y4: 58.75, y5: 60.03},
    {x: 47, y1: 52.87, y2: 54.13, y3: 56.83, y4: 59.53, y5: 60.79},
    {x: 48, y1: 53.67, y2: 54.92, y3: 57.59, y4: 60.26, y5: 61.51},
    {x: 49, y1: 54.47, y2: 55.71, y3: 58.35, y4: 60.99, y5: 62.22},
    {x: 50, y1: 55.22, y2: 56.44, y3: 59.04, y4: 61.65, y5: 62.87}  
  ];
  
  export const girlsLengthData: DataPoint[] = [
    {x: 24, y1: 25.88, y2: 27.26, y3: 30.2, y4: 33.14, y5: 34.515},
    {x: 25, y1: 27.215, y2: 28.61, y3: 31.59, y4: 34.57, y5: 35.965},
    {x: 26, y1: 28.585, y2: 30, y3: 33.01, y4: 36.03, y5: 37.44},
    {x: 27, y1: 29.99, y2: 31.41, y3: 34.46, y4: 37.51, y5: 38.935},
    {x: 28, y1: 31.41, y2: 32.85, y3: 35.92, y4: 38.99, y5: 40.425},
    {x: 29, y1: 32.825, y2: 34.27, y3: 37.36, y4: 40.45, y5: 41.89},
    {x: 30, y1: 34.25, y2: 35.7, y3: 38.795, y4: 41.895, y5: 43.345},
    {x: 31, y1: 35.655, y2: 37.1, y3: 40.205, y4: 43.31, y5: 44.755},
    {x: 32, y1: 37.01, y2: 38.46, y3: 41.55, y4: 44.65, y5: 46.095},
    {x: 33, y1: 38.29, y2: 39.73, y3: 42.81, y4: 45.895, y5: 47.335},
    {x: 34, y1: 39.565, y2: 41, y3: 44.06, y4: 47.13, y5: 48.56},
    {x: 35, y1: 40.83, y2: 42.26, y3: 45.305, y4: 48.35, y5: 49.775},
    {x: 36, y1: 42.01, y2: 43.42, y3: 46.445, y4: 49.47, y5: 50.885},
    {x: 37, y1: 43.105, y2: 44.51, y3: 47.5, y4: 50.5, y5: 51.895},
    {x: 38, y1: 44.105, y2: 45.49, y3: 48.455, y4: 51.42, y5: 52.805},
    {x: 39, y1: 45.04, y2: 46.41, y3: 49.345, y4: 52.28, y5: 53.645},
    {x: 40, y1: 45.935, y2: 47.29, y3: 50.19, y4: 53.09, y5: 54.45},
    {x: 41, y1: 46.805, y2: 48.15, y3: 51.02, y4: 53.895, y5: 55.235},
    {x: 42, y1: 47.67, y2: 49, y3: 51.845, y4: 54.69, y5: 56.025},
    {x: 43, y1: 48.515, y2: 49.835, y3: 52.655, y4: 55.48, y5: 56.795},
    {x: 44, y1: 49.335, y2: 50.645, y3: 53.445, y4: 56.24, y5: 57.545},
    {x: 45, y1: 50.13, y2: 51.43, y3: 54.2, y4: 56.975, y5: 58.275},
    {x: 46, y1: 50.885, y2: 52.165, y3: 54.915, y4: 57.67, y5: 58.95},
    {x: 47, y1: 51.6, y2: 52.87, y3: 55.6, y4: 58.325, y5: 59.595},
    {x: 48, y1: 52.345, y2: 53.61, y3: 56.315, y4: 59.02, y5: 60.275},
    {x: 49, y1: 53.095, y2: 54.34, y3: 57.025, y4: 59.705, y5: 60.955},
    {x: 50, y1: 53.725, y2: 54.96, y3: 57.615, y4: 60.27, y5: 61.505}
  ];

  export const boysHeadData: DataPoint[] = [
    {x: 23, y1: 17.985, y2: 18.76, y3: 20.435, y4: 22.11, y5: 22.885},
    {x: 24, y1: 19.025, y2: 19.82, y3: 21.52, y4: 23.225, y5: 24.025},
    {x: 25, y1: 20.025, y2: 20.84, y3: 22.59, y4: 24.335, y5: 25.155},
    {x: 26, y1: 20.985, y2: 21.82, y3: 23.62, y4: 25.42, y5: 26.265},
    {x: 27, y1: 21.955, y2: 22.825, y3: 24.675, y4: 26.525, y5: 27.39},
    {x: 28, y1: 22.955, y2: 23.84, y3: 25.74, y4: 27.64, y5: 28.535},
    {x: 29, y1: 23.995, y2: 24.885, y3: 26.79, y4: 28.69, y5: 29.585},
    {x: 30, y1: 24.955, y2: 25.85, y3: 27.76, y4: 29.67, y5: 30.565},
    {x: 31, y1: 25.825, y2: 26.74, y3: 28.7, y4: 30.66, y5: 31.575},
    {x: 32, y1: 26.775, y2: 27.7, y3: 29.665, y4: 31.64, y5: 32.56},
    {x: 33, y1: 27.735, y2: 28.65, y3: 30.6, y4: 32.55, y5: 33.465},
    {x: 34, y1: 28.69, y2: 29.585, y3: 31.5, y4: 33.41, y5: 34.305},
    {x: 35, y1: 29.585, y2: 30.46, y3: 32.33, y4: 34.2, y5: 35.075},
    {x: 36, y1: 30.355, y2: 31.21, y3: 33.04, y4: 34.87, y5: 35.725},
    {x: 37, y1: 31.055, y2: 31.89, y3: 33.67, y4: 35.45, y5: 36.285},
    {x: 38, y1: 31.705, y2: 32.52, y3: 34.265, y4: 36.005, y5: 36.825},
    {x: 39, y1: 32.325, y2: 33.125, y3: 34.825, y4: 36.525, y5: 37.325},
    {x: 40, y1: 32.915, y2: 33.695, y3: 35.355, y4: 37.015, y5: 37.795},
    {x: 41, y1: 33.475, y2: 34.235, y3: 35.86, y4: 37.48, y5: 38.235},
    {x: 42, y1: 34.015, y2: 34.75, y3: 36.335, y4: 37.92, y5: 38.655},
    {x: 43, y1: 34.525, y2: 35.245, y3: 36.79, y4: 38.33, y5: 39.055},
    {x: 44, y1: 35, y2: 35.71, y3: 37.22, y4: 38.73, y5: 39.435},
    {x: 45, y1: 35.43, y2: 36.13, y3: 37.625, y4: 39.12, y5: 39.82},
    {x: 46, y1: 35.815, y2: 36.51, y3: 38.01, y4: 39.51, y5: 40.205},
    {x: 47, y1: 36.185, y2: 36.885, y3: 38.385, y4: 39.885, y5: 40.585},
    {x: 48, y1: 36.525, y2: 37.23, y3: 38.73, y4: 40.225, y5: 40.925},
    {x: 49, y1: 36.84, y2: 37.54, y3: 39.04, y4: 40.54, y5: 41.245},
    {x: 50, y1: 37.2, y2: 37.9, y3: 39.4, y4: 40.9, y5: 41.6}
  ];
  
  export const girlsHeadData: DataPoint[] = [
    {x: 23, y1: 17.5, y2: 18.28, y3: 19.97, y4: 21.65, y5: 22.44},
    {x: 24, y1: 18.56, y2: 19.36, y3: 21.04, y4: 22.73, y5: 23.52},
    {x: 25, y1: 19.62, y2: 20.42, y3: 22.11, y4: 23.81, y5: 24.6},
    {x: 26, y1: 20.62, y2: 21.43, y3: 23.16, y4: 24.9, y5: 25.71},
    {x: 27, y1: 21.6, y2: 22.43, y3: 24.21, y4: 26, y5: 26.83},
    {x: 28, y1: 22.58, y2: 23.44, y3: 25.26, y4: 27.08, y5: 27.93},
    {x: 29, y1: 23.61, y2: 24.47, y3: 26.32, y4: 28.16, y5: 29.02},
    {x: 30, y1: 24.56, y2: 25.43, y3: 27.29, y4: 29.15, y5: 30.02},
    {x: 31, y1: 25.46, y2: 26.34, y3: 28.24, y4: 30.13, y5: 31.02},
    {x: 32, y1: 26.41, y2: 27.3, y3: 29.2, y4: 31.1, y5: 31.99},
    {x: 33, y1: 27.34, y2: 28.22, y3: 30.1, y4: 31.99, y5: 32.88},
    {x: 34, y1: 28.24, y2: 29.11, y3: 30.97, y4: 32.83, y5: 33.7},
    {x: 35, y1: 29.12, y2: 29.96, y3: 31.79, y4: 33.61, y5: 34.46},
    {x: 36, y1: 29.9, y2: 30.74, y3: 32.53, y4: 34.33, y5: 35.17},
    {x: 37, y1: 30.59, y2: 31.41, y3: 33.17, y4: 34.92, y5: 35.74},
    {x: 38, y1: 31.2, y2: 32, y3: 33.72, y4: 35.43, y5: 36.23},
    {x: 39, y1: 31.76, y2: 32.55, y3: 34.24, y4: 35.91, y5: 36.7},
    {x: 40, y1: 32.29, y2: 33.06, y3: 34.72, y4: 36.37, y5: 37.14},
    {x: 41, y1: 32.8, y2: 33.56, y3: 35.18, y4: 36.79, y5: 37.55},
    {x: 42, y1: 33.28, y2: 34.02, y3: 35.61, y4: 37.21, y5: 37.95},
    {x: 43, y1: 33.73, y2: 34.46, y3: 36.03, y4: 37.6, y5: 38.34},
    {x: 44, y1: 34.15, y2: 34.88, y3: 36.43, y4: 37.99, y5: 38.71},
    {x: 45, y1: 34.54, y2: 35.27, y3: 36.82, y4: 38.36, y5: 39.08},
    {x: 46, y1: 34.92, y2: 35.64, y3: 37.19, y4: 38.74, y5: 39.46},
    {x: 47, y1: 35.3, y2: 36.02, y3: 37.56, y4: 39.11, y5: 39.83},
    {x: 48, y1: 35.68, y2: 36.4, y3: 37.93, y4: 39.46, y5: 40.17},
    {x: 49, y1: 36, y2: 36.72, y3: 38.25, y4: 39.78, y5: 40.5},
    {x: 50, y1: 36.25, y2: 36.98, y3: 38.52, y4: 40.08, y5: 40.8}
  ];

  export const boysWeightData: DataPoint[] = [
  {x: 23, y1: 0.401, y2: 0.449, y3: 0.5505, y4: 0.651, y5: 0.698},
  {x: 24, y1: 0.4725, y2: 0.5285, y3: 0.6455, y4: 0.76, y5: 0.813},
  {x: 25, y1: 0.5515, y2: 0.6165, y3: 0.7525, y4: 0.884, y5: 0.9445},
  {x: 26, y1: 0.638, y2: 0.715, y3: 0.873, y4: 1.0255, y5: 1.095},
  {x: 27, y1: 0.733, y2: 0.821, y3: 1.004, y4: 1.1815, y5: 1.262},
  {x: 28, y1: 0.84, y2: 0.9355, y3: 1.141, y4: 1.348, y5: 1.446},
  {x: 29, y1: 0.96, y2: 1.059, y3: 1.284, y4: 1.527, y5: 1.648},
  {x: 30, y1: 1.091, y2: 1.193, y3: 1.437, y4: 1.722, y5: 1.87},
  {x: 31, y1: 1.228, y2: 1.337, y3: 1.605, y4: 1.934, y5: 2.112},
  {x: 32, y1: 1.373, y2: 1.493, y3: 1.792, y4: 2.162, y5: 2.365},
  {x: 33, y1: 1.53, y2: 1.665, y3: 1.998, y4: 2.407, y5: 2.63},
  {x: 34, y1: 1.702, y2: 1.852, y3: 2.22, y4: 2.665, y5: 2.905},
  {x: 35, y1: 1.88, y2: 2.046, y3: 2.448, y4: 2.927, y5: 3.18},
  {x: 36, y1: 2.06, y2: 2.24, y3: 2.672, y4: 3.185, y5: 3.455},
  {x: 37, y1: 2.237, y2: 2.428, y3: 2.891, y4: 3.435, y5: 3.72},
  {x: 38, y1: 2.415, y2: 2.617, y3: 3.107, y4: 3.685, y5: 3.985},
  {x: 39, y1: 2.59, y2: 2.806, y3: 3.325, y4: 3.935, y5: 4.25},
  {x: 40, y1: 2.77, y2: 2.997, y3: 3.543, y4: 4.185, y5: 4.515},
  {x: 41, y1: 2.945, y2: 3.186, y3: 3.762, y4: 4.435, y5: 4.785},
  {x: 42, y1: 3.125, y2: 3.376, y3: 3.982, y4: 4.685, y5: 5.05},
  {x: 43, y1: 3.3, y2: 3.567, y3: 4.201, y4: 4.935, y5: 5.315},
  {x: 44, y1: 3.48, y2: 3.757, y3: 4.421, y4: 5.185, y5: 5.58},
  {x: 45, y1: 3.655, y2: 3.946, y3: 4.64, y4: 5.437, y5: 5.845},
  {x: 46, y1: 3.83, y2: 4.135, y3: 4.86, y4: 5.69, y5: 6.11},
  {x: 47, y1: 4.005, y2: 4.325, y3: 5.078, y4: 5.94, y5: 6.38},
  {x: 48, y1: 4.18, y2: 4.512, y3: 5.296, y4: 6.19, y5: 6.645},
  {x: 49, y1: 4.355, y2: 4.7, y3: 5.515, y4: 6.44, y5: 6.915},
  {x: 50, y1: 4.53, y2: 4.89, y3: 5.733, y4: 6.69, y5: 7.18}
];
  
  export const girlsWeightData: DataPoint[] = [
    {x: 23, y1: 0.391, y2: 0.4275, y3: 0.514, y4: 0.6099, y5: 0.658},
    {x: 24, y1: 0.4565, y2: 0.502, y3: 0.6055, y4: 0.716, y5: 0.7705},
    {x: 25, y1: 0.53, y2: 0.585, y3: 0.708, y4: 0.836, y5: 0.897},
    {x: 26, y1: 0.613, y2: 0.679, y3: 0.824, y4: 0.972, y5: 1.042},
    {x: 27, y1: 0.704, y2: 0.781, y3: 0.948, y4: 1.12, y5: 1.2015},
    {x: 28, y1: 0.802, y2: 0.888, y3: 1.078, y4: 1.277, y5: 1.372},
    {x: 29, y1: 0.907, y2: 1.002, y3: 1.215, y4: 1.445, y5: 1.558},
    {x: 30, y1: 1.023, y2: 1.126, y3: 1.365, y4: 1.632, y5: 1.767},
    {x: 31, y1: 1.151, y2: 1.265, y3: 1.534, y4: 1.8435, y5: 2.0025},
    {x: 32, y1: 1.292, y2: 1.4185, y3: 1.723, y4: 2.0765, y5: 2.261},
    {x: 33, y1: 1.444, y2: 1.586, y3: 1.926, y4: 2.3225, y5: 2.529},
    {x: 34, y1: 1.606, y2: 1.764, y3: 2.139, y4: 2.5725, y5: 2.797},
    {x: 35, y1: 1.777, y2: 1.949, y3: 2.358, y4: 2.8265, y5: 3.066},
    {x: 36, y1: 1.9505, y2: 2.137, y3: 2.578, y4: 3.082, y5: 3.34},
    {x: 37, y1: 2.125, y2: 2.324, y3: 2.796, y4: 3.341, y5: 3.622},
    {x: 38, y1: 2.294, y2: 2.504, y3: 3.008, y4: 3.602, y5: 3.912},
    {x: 39, y1: 2.46, y2: 2.679, y3: 3.215, y4: 3.857, y5: 4.195},
    {x: 40, y1: 2.615, y2: 2.849, y3: 3.415, y4: 4.1, y5: 4.465},
    {x: 41, y1: 2.77, y2: 3.014, y3: 3.61, y4: 4.33, y5: 4.715},
    {x: 42, y1: 2.924, y2: 3.18, y3: 3.805, y4: 4.55, y5: 4.945},
    {x: 43, y1: 3.079, y2: 3.345, y3: 3.99, y4: 4.76, y5: 5.165},
    {x: 44, y1: 3.235, y2: 3.51, y3: 4.175, y4: 4.965, y5: 5.377},
    {x: 45, y1: 3.39, y2: 3.675, y3: 4.36, y4: 5.165, y5: 5.587},
    {x: 46, y1: 3.543, y2: 3.835, y3: 4.545, y4: 5.37, y5: 5.8},
    {x: 47, y1: 3.69, y2: 3.995, y3: 4.725, y4: 5.577, y5: 6.022},
    {x: 48, y1: 3.84, y2: 4.154, y3: 4.91, y4: 5.79, y5: 6.247},
    {x: 49, y1: 3.98, y2: 4.309, y3: 5.09, y4: 6, y5: 6.475},
    {x: 50, y1: 4.125, y2: 4.464, y3: 5.27, y4: 6.215, y5: 6.702}
  ];

  // For clarity, you might want to add some constants that are used with this data
  export const PERCENTILE_NAMES_FENTION = ["3", "10", "50", "90", "97"];
  export const PERCENTILE_NAMES_WHO = ["2.3", "5", "10", "25", "50", "75", "90", "95", "97.7"];
  export const CHART_AXIS_CONFIG_FENTON = {
    LENGTH: {
      TICKS_X: [23, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42],
      TICKS_Y: [23, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60],
      DOMAIN_X: [23, 50],
      DOMAIN_Y: [23, 60]
    },
    HEAD: {
      TICKS_X: [23, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42],
      TICKS_Y: [16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44],
      DOMAIN_X: [23, 50],
      DOMAIN_Y: [17, 44]
    },
    WIEGHT: {
      TICKS_X: [22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42],
      TICKS_Y: [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5],
      DOMAIN_X: [22, 50],
      DOMAIN_Y: [0, 8]
    }
  };
  export const CHART_AXIS_CONFIG_WHO = {
    LENGTH: {
      TICKS_X: [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24],
      TICKS_Y: [48, 52, 56, 60, 64, 68, 72, 76, 80, 84, 88, 90, 94, 96],
      DOMAIN_X: [0, 24],
      DOMAIN_Y: [48, 96]
    },
    HEAD: {
      TICKS_X: [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24],
      TICKS_Y: [33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51],
      DOMAIN_X: [0, 24],
      DOMAIN_Y: [33, 51]
    },
    WIEGHT: {
      TICKS_X: [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24],
      TICKS_Y: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      DOMAIN_X: [0, 24],
      DOMAIN_Y: [2, 16]
    }
  };

  export const boysLengthDataWHO: DataPoint[] = [
    { x: 0, l: 1, m: 49.8842, s: 0.03795, y1: 46.09799, y2: 46.77032, y3: 47.45809, y4: 48.60732, y5: 49.8842, y6: 51.16108, y7: 52.31031, y8: 52.99808, y9: 53.67041 },
    { x: 1, l: 1, m: 54.7244, s: 0.03557, y1: 50.83131, y2: 51.52262, y3: 52.2298, y4: 53.41147, y5: 54.7244, y6: 56.03733, y7: 57.219, y8: 57.92618, y9: 58.61749 },
    { x: 2, l: 1, m: 58.4249, s: 0.03424, y1: 54.42396, y2: 55.13442, y3: 55.8612, y4: 57.0756, y5: 58.4249, y6: 59.7742, y7: 60.9886, y8: 61.71538, y9: 62.42584 },
    { x: 3, l: 1, m: 61.4292, s: 0.03328, y1: 57.34047, y2: 58.06652, y3: 58.80924, y4: 60.0503, y5: 61.4292, y6: 62.8081, y7: 64.04916, y8: 64.79188, y9: 65.51793 },
    { x: 4, l: 1, m: 63.886, s: 0.03257, y1: 59.72447, y2: 60.46344, y3: 61.21939, y4: 62.48254, y5: 63.886, y6: 65.28946, y7: 66.55261, y8: 67.30856, y9: 68.04753 },
    { x: 5, l: 1, m: 65.9026, s: 0.03204, y1: 61.67956, y2: 62.42946, y3: 63.19658, y4: 64.4784, y5: 65.9026, y6: 67.3268, y7: 68.60862, y8: 69.37574, y9: 70.12564 },
    { x: 6, l: 1, m: 67.6236, s: 0.03165, y1: 63.34303, y2: 64.10314, y3: 64.88071, y4: 66.18, y5: 67.6236, y6: 69.0672, y7: 70.36649, y8: 71.14406, y9: 71.90417 },
    { x: 7, l: 1, m: 69.1645, s: 0.03139, y1: 64.82235, y2: 65.5934, y3: 66.38216, y4: 67.70013, y5: 69.1645, y6: 70.62887, y7: 71.94684, y8: 72.7356, y9: 73.50665 },
    { x: 8, l: 1, m: 70.5994, s: 0.03124, y1: 66.18835, y2: 66.97163, y3: 67.77291, y4: 69.1118, y5: 70.5994, y6: 72.087, y7: 73.42589, y8: 74.22717, y9: 75.01045 },
    { x: 9, l: 1, m: 71.9687, s: 0.03117, y1: 67.48217, y2: 68.27886, y3: 69.09384, y4: 70.45564, y5: 71.9687, y6: 73.48176, y7: 74.84356, y8: 75.65854, y9: 76.45523 },
    { x: 10, l: 1, m: 73.2812, s: 0.03118, y1: 68.71138, y2: 69.52286, y3: 70.35297, y4: 71.74005, y5: 73.2812, y6: 74.82235, y7: 76.20943, y8: 77.03954, y9: 77.85102 },
    { x: 11, l: 1, m: 74.5388, s: 0.03125, y1: 69.88013, y2: 70.70738, y3: 71.55363, y4: 72.96769, y5: 74.5388, y6: 76.10991, y7: 77.52397, y8: 78.37022, y9: 79.19748 },
    { x: 12, l: 1, m: 75.7488, s: 0.03137, y1: 70.99632, y2: 71.84023, y3: 72.70353, y4: 74.14605, y5: 75.7488, y6: 77.35155, y7: 78.79407, y8: 79.65737, y9: 80.50128 },
    { x: 13, l: 1, m: 76.9186, s: 0.03154, y1: 72.06657, y2: 72.92816, y3: 73.80954, y4: 75.28228, y5: 76.9186, y6: 78.55492, y7: 80.02766, y8: 80.90904, y9: 81.77063 },
    { x: 14, l: 1, m: 78.0497, s: 0.03174, y1: 73.09511, y2: 73.97491, y3: 74.87492, y4: 76.37879, y5: 78.0497, y6: 79.72061, y7: 81.22448, y8: 82.12449, y9: 83.0043 },
    { x: 15, l: 1, m: 79.1458, s: 0.03197, y1: 74.08522, y2: 74.98384, y3: 75.9031, y4: 77.43914, y5: 79.1458, y6: 80.85246, y7: 82.3885, y8: 83.30776, y9: 84.20638 },
    { x: 16, l: 1, m: 80.2113, s: 0.03222, y1: 75.04248, y2: 75.96033, y3: 76.89925, y4: 78.46814, y5: 80.2113, y6: 81.95446, y7: 83.52335, y8: 84.46227, y9: 85.38012 },
    { x: 17, l: 1, m: 81.2487, s: 0.0325, y1: 75.96753, y2: 76.90533, y3: 77.86466, y4: 79.46765, y5: 81.2487, y6: 83.02975, y7: 84.63274, y8: 85.59207, y9: 86.52987 },
    { x: 18, l: 1, m: 82.2587, s: 0.03279, y1: 76.86417, y2: 77.8221, y3: 78.80202, y4: 80.43942, y5: 82.2587, y6: 84.07798, y7: 85.71538, y8: 86.6953, y9: 87.65323 },
    { x: 19, l: 1, m: 83.2418, s: 0.0331, y1: 77.73119, y2: 78.70973, y3: 79.71074, y4: 81.38338, y5: 83.2418, y6: 85.10022, y7: 86.77286, y8: 87.77387, y9: 88.75241 },
    { x: 20, l: 1, m: 84.1996, s: 0.03342, y1: 78.5717, y2: 79.57106, y3: 80.59338, y4: 82.30162, y5: 84.1996, y6: 86.09758, y7: 87.80582, y8: 88.82814, y9: 89.8275 },
    { x: 21, l: 1, m: 85.1348, s: 0.03376, y1: 79.3865, y2: 80.40724, y3: 81.45143, y4: 83.19621, y5: 85.1348, y6: 87.07339, y7: 88.81817, y8: 89.86236, y9: 90.8831 },
    { x: 22, l: 1, m: 86.0477, s: 0.0341, y1: 80.17925, y2: 81.22133, y3: 82.28734, y4: 84.06859, y5: 86.0477, y6: 88.02681, y7: 89.80806, y8: 90.87407, y9: 91.91615 },
    { x: 23, l: 1, m: 86.941, s: 0.03445, y1: 80.95077, y2: 82.01447, y3: 83.1026, y4: 84.92082, y5: 86.941, y6: 88.96118, y7: 90.7794, y8: 91.86753, y9: 92.93123 },
    { x: 24, l: 1, m: 87.8161, s: 0.03479, y1: 81.70586, y2: 82.79087, y3: 83.9008, y4: 85.75545, y5: 87.8161, y6: 89.87675, y7: 91.7314, y8: 92.84133, y9: 93.92634 }
  ];

  export const girlsLengthDataWHO: DataPoint[] = [
    { x: 0, l: 1, m: 49.1477, s: 0.0379, y1: 45.422304, y2: 46.08383, y3: 46.76056, y4: 47.89133, y5: 49.1477, y6: 50.40407, y7: 51.53484, y8: 52.21157, y9: 52.873096 },
    { x: 1, l: 1, m: 53.6872, s: 0.0364, y1: 49.778772, y2: 50.4728, y3: 51.18277, y4: 52.3691, y5: 53.6872, y6: 55.0053, y7: 56.19163, y8: 56.9016, y9: 57.595628 },
    { x: 2, l: 1, m: 57.0673, s: 0.03568, y1: 52.994978, y2: 53.71811, y3: 54.45785, y4: 55.69393, y5: 57.0673, y6: 58.44067, y7: 59.67675, y8: 60.41649, y9: 61.139623 },
    { x: 3, l: 1, m: 59.8029, s: 0.0352, y1: 55.592776, y2: 56.34038, y3: 57.10515, y4: 58.38306, y5: 59.8029, y6: 61.22274, y7: 62.50065, y8: 63.26542, y9: 64.013024 },
    { x: 4, l: 1, m: 62.0899, s: 0.03486, y1: 57.760992, y2: 58.52969, y3: 59.31604, y4: 60.63, y5: 62.0899, y6: 63.5498, y7: 64.86376, y8: 65.65011, y9: 66.418808 },
    { x: 5, l: 1, m: 64.0301, s: 0.03463, y1: 59.595375, y2: 60.38286, y3: 61.18844, y4: 62.53451, y5: 64.0301, y6: 65.52569, y7: 66.87176, y8: 67.67734, y9: 68.464825 },
    { x: 6, l: 1, m: 65.7311, s: 0.03448, y1: 61.198283, y2: 62.00319, y3: 62.82658, y4: 64.20243, y5: 65.7311, y6: 67.25977, y7: 68.63562, y8: 69.45901, y9: 70.263917 },
    { x: 7, l: 1, m: 67.2873, s: 0.03441, y1: 62.656588, y2: 63.47888, y3: 64.32005, y4: 65.72562, y5: 67.2873, y6: 68.84898, y7: 70.25455, y8: 71.09572, y9: 71.918012 },
    { x: 8, l: 1, m: 68.7498, s: 0.0344, y1: 64.019814, y2: 64.85973, y3: 65.71894, y4: 67.15464, y5: 68.7498, y6: 70.34496, y7: 71.78066, y8: 72.63987, y9: 73.479786 },
    { x: 9, l: 1, m: 70.1435, s: 0.03444, y1: 65.312016, y2: 66.16996, y3: 67.0476, y4: 68.51411, y5: 70.1435, y6: 71.77289, y7: 73.2394, y8: 74.11704, y9: 74.974984 },
    { x: 10, l: 1, m: 71.4818, s: 0.03452, y1: 66.546697, y2: 67.42304, y3: 68.31951, y4: 69.81746, y5: 71.4818, y6: 73.14614, y7: 74.64409, y8: 75.54056, y9: 76.416904 },
    { x: 11, l: 1, m: 72.771, s: 0.03464, y1: 67.729425, y2: 68.62467, y3: 69.54048, y4: 71.07075, y5: 72.771, y6: 74.47125, y7: 76.00152, y8: 76.91733, y9: 77.812575 },
    { x: 12, l: 1, m: 74.015, s: 0.03479, y1: 68.865036, y2: 69.77953, y3: 70.71503, y4: 72.2782, y5: 74.015, y6: 75.7518, y7: 77.31497, y8: 78.25047, y9: 79.164964 },
    { x: 13, l: 1, m: 75.2176, s: 0.03496, y1: 69.958385, y2: 70.89228, y3: 71.84762, y4: 73.44396, y5: 75.2176, y6: 76.99124, y7: 78.58758, y8: 79.54292, y9: 80.476815 },
    { x: 14, l: 1, m: 76.3817, s: 0.03514, y1: 71.013594, y2: 71.96683, y3: 72.94195, y4: 74.57133, y5: 76.3817, y6: 78.19207, y7: 79.82145, y8: 80.79657, y9: 81.749806 },
    { x: 15, l: 1, m: 77.5099, s: 0.03534, y1: 72.0315, y2: 73.00432, y3: 73.99947, y4: 75.66234, y5: 77.5099, y6: 79.35746, y7: 81.02033, y8: 82.01548, y9: 82.9883 },
    { x: 16, l: 1, m: 78.6055, s: 0.03555, y1: 73.016649, y2: 74.00908, y3: 75.0243, y4: 76.72069, y5: 78.6055, y6: 80.49031, y7: 82.1867, y8: 83.20192, y9: 84.194351 },
    { x: 17, l: 1, m: 79.671, s: 0.03576, y1: 73.97293, y2: 74.98475, y3: 76.01981, y4: 77.74936, y5: 79.671, y6: 81.59264, y7: 83.32219, y8: 84.35725, y9: 85.36907 },
    { x: 18, l: 1, m: 80.7079, s: 0.03598, y1: 74.90016, y2: 75.93146, y3: 76.98644, y4: 78.74927, y5: 80.7079, y6: 82.66653, y7: 84.42936, y8: 85.48434, y9: 86.515641 },
    { x: 19, l: 1, m: 81.7182, s: 0.0362, y1: 75.801802, y2: 76.8524, y3: 77.92712, y4: 79.72293, y5: 81.7182, y6: 83.71347, y7: 85.50928, y8: 86.584, y9: 87.634598 },
    { x: 20, l: 1, m: 82.7036, s: 0.03643, y1: 76.677816, y2: 77.74783, y3: 78.84242, y4: 80.67144, y5: 82.7036, y6: 84.73576, y7: 86.56478, y8: 87.65937, y9: 88.729384 },
    { x: 21, l: 1, m: 83.6654, s: 0.03666, y1: 77.531053, y2: 78.62035, y3: 79.73466, y4: 81.59662, y5: 83.6654, y6: 85.73418, y7: 87.59614, y8: 88.71045, y9: 89.799747 },
    { x: 22, l: 1, m: 84.604, s: 0.03688, y1: 78.363609, y2: 79.47174, y3: 80.60531, y4: 82.49946, y5: 84.604, y6: 86.70854, y7: 88.60269, y8: 89.73626, y9: 90.844391 },
    { x: 23, l: 1, m: 85.5202, s: 0.03711, y1: 79.172891, y2: 80.3, y3: 81.453, y4: 83.3796, y5: 85.5202, y6: 87.6608, y7: 89.5874, y8: 90.7404, y9: 91.867509 },
    { x: 24, l: 1, m: 86.4153, s: 0.03734, y1: 79.961805, y2: 81.10777, y3: 82.28006, y4: 84.23889, y5: 86.4153, y6: 88.59171, y7: 90.55054, y8: 91.72283, y9: 92.868795 }  
  ];

  export const boysHeadDataWHO: DataPoint[] = [
    { x: 0, l: 1, m: 34.4618, s: 0.03686, y1: 31.92128, y2: 32.37241, y3: 32.83389, y4: 33.60502, y5: 34.4618, y6: 35.31858, y7: 36.08971, y8: 36.55119, y9: 37.002324 },
    { x: 1, l: 1, m: 37.2759, s: 0.03133, y1: 34.94019, y2: 35.35495, y3: 35.77923, y4: 36.48819, y5: 37.2759, y6: 38.06361, y7: 38.77257, y8: 39.19685, y9: 39.611608 },
    { x: 2, l: 1, m: 39.1285, s: 0.02997, y1: 36.78314, y2: 37.19961, y3: 37.62565, y4: 38.33754, y5: 39.1285, y6: 39.91946, y7: 40.63135, y8: 41.05739, y9: 41.473862 },
    { x: 3, l: 1, m: 40.5135, s: 0.02918, y1: 38.14913, y2: 38.56898, y3: 38.99847, y4: 39.71613, y5: 40.5135, y6: 41.31087, y7: 42.02853, y8: 42.45802, y9: 42.877868 },
    { x: 4, l: 1, m: 41.6317, s: 0.02868, y1: 39.24371, y2: 39.66775, y3: 40.10153, y4: 40.82636, y5: 41.6317, y6: 42.43704, y7: 43.16187, y8: 43.59565, y9: 44.019694 },
    { x: 5, l: 1, m: 42.5576, s: 0.02837, y1: 40.14288, y2: 40.57167, y3: 41.01031, y4: 41.74325, y5: 42.5576, y6: 43.37195, y7: 44.10489, y8: 44.54353, y9: 44.972318 },
    { x: 6, l: 1, m: 43.3306, s: 0.02817, y1: 40.88935, y2: 41.32285, y3: 41.76631, y4: 42.5073, y5: 43.3306, y6: 44.1539, y7: 44.89489, y8: 45.33835, y9: 45.771846 },
    { x: 7, l: 1, m: 43.9803, s: 0.02804, y1: 41.51388, y2: 41.95185, y3: 42.39988, y4: 43.14851, y5: 43.9803, y6: 44.81209, y7: 45.56072, y8: 46.00875, y9: 46.446715 },
    { x: 8, l: 1, m: 44.53, s: 0.02796, y1: 42.03988, y2: 42.48206, y3: 42.93439, y4: 43.69022, y5: 44.53, y6: 45.36978, y7: 46.12561, y8: 46.57794, y9: 47.020118 },
    { x: 9, l: 1, m: 44.9998, s: 0.02792, y1: 42.48701, y2: 42.93322, y3: 43.38967, y4: 44.15237, y5: 44.9998, y6: 45.84723, y7: 46.60993, y8: 47.06638, y9: 47.512589 },
    { x: 10, l: 1, m: 45.4051, s: 0.0279, y1: 42.8715, y2: 43.3214, y3: 43.78163, y4: 44.55065, y5: 45.4051, y6: 46.25955, y7: 47.02857, y8: 47.4888, y9: 47.938705 },
    { x: 11, l: 1, m: 45.7573, s: 0.02789, y1: 43.20496, y2: 43.65819, y3: 44.12182, y4: 44.89654, y5: 45.7573, y6: 46.61806, y7: 47.39278, y8: 47.85641, y9: 48.309642 },
    { x: 12, l: 1, m: 46.0661, s: 0.02789, y1: 43.49653, y2: 43.95282, y3: 44.41958, y4: 45.19953, y5: 46.0661, y6: 46.93267, y7: 47.71262, y8: 48.17938, y9: 48.635667 },
    { x: 13, l: 1, m: 46.3395, s: 0.02789, y1: 43.75468, y2: 44.21368, y3: 44.68321, y4: 45.46778, y5: 46.3395, y6: 47.21122, y7: 47.99579, y8: 48.46532, y9: 48.924317 },
    { x: 14, l: 1, m: 46.5844, s: 0.02791, y1: 43.98406, y2: 44.44581, y3: 44.91816, y4: 45.70745, y5: 46.5844, y6: 47.46135, y7: 48.25064, y8: 48.72299, y9: 49.184741 },
    { x: 15, l: 1, m: 46.806, s: 0.02792, y1: 44.19235, y2: 44.65647, y3: 45.13124, y4: 45.92456, y5: 46.806, y6: 47.68744, y7: 48.48076, y8: 48.95553, y9: 49.419647 },
    { x: 16, l: 1, m: 47.0088, s: 0.02795, y1: 44.38101, y2: 44.84763, y3: 45.32497, y4: 46.12259, y5: 47.0088, y6: 47.89501, y7: 48.69263, y8: 49.16997, y9: 49.636592 },
    { x: 17, l: 1, m: 47.1962, s: 0.02797, y1: 44.55604, y2: 45.02487, y3: 45.50445, y4: 46.30582, y5: 47.1962, y6: 48.08658, y7: 48.88795, y8: 49.36753, y9: 49.836355 },
    { x: 18, l: 1, m: 47.3711, s: 0.028, y1: 44.71832, y2: 45.18938, y3: 45.67126, y4: 46.47646, y5: 47.3711, y6: 48.26574, y7: 49.07094, y8: 49.55282, y9: 50.023882 },
    { x: 19, l: 1, m: 47.5357, s: 0.02803, y1: 44.87085, y2: 45.34405, y3: 45.82813, y4: 46.63699, y5: 47.5357, y6: 48.43441, y7: 49.24327, y8: 49.72735, y9: 50.200551 },
    { x: 20, l: 1, m: 47.6919, s: 0.02806, y1: 45.01543, y2: 45.4907, y3: 45.97688, y4: 46.78927, y5: 47.6919, y6: 48.59453, y7: 49.40692, y8: 49.8931, y9: 50.368369 },
    { x: 21, l: 1, m: 47.8408, s: 0.0281, y1: 45.15215, y2: 45.62958, y3: 46.11798, y4: 46.93407, y5: 47.8408, y6: 48.74753, y7: 49.56362, y8: 50.05202, y9: 50.529453 },
    { x: 22, l: 1, m: 47.9833, s: 0.02813, y1: 45.28376, y2: 45.76313, y3: 46.2535, y4: 47.07289, y5: 47.9833, y6: 48.89371, y7: 49.7131, y8: 50.20347, y9: 50.682841 },
    { x: 23, l: 1, m: 48.1201, s: 0.02817, y1: 45.40901, y2: 45.89043, y3: 46.3829, y4: 47.2058, y5: 48.1201, y6: 49.0344, y7: 49.8573, y8: 50.34977, y9: 50.831186 },
    { x: 24, l: 1, m: 48.2515, s: 0.02821, y1: 45.52915, y2: 46.01257, y3: 46.50708, y4: 47.3334, y5: 48.2515, y6: 49.1696, y7: 49.99592, y8: 50.49043, y9: 50.97385 }
  ];

  export const girlsHeadDataWHO: DataPoint[] = [
    { x: 0, l: 1, m: 33.8787, s: 0.03496, y1: 31.5099, y2: 31.93054, y3: 32.36083, y4: 33.07983, y5: 33.8787, y6: 34.67757, y7: 35.39657, y8: 35.82686, y9: 36.247499 },
    { x: 1, l: 1, m: 36.5463, s: 0.0321, y1: 34.20003, y2: 34.61666, y3: 35.04287, y4: 35.75503, y5: 36.5463, y6: 37.33757, y7: 38.04973, y8: 38.47594, y9: 38.892573 },
    { x: 2, l: 1, m: 38.2521, s: 0.03168, y1: 35.82845, y2: 36.25882, y3: 36.69908, y4: 37.43474, y5: 38.2521, y6: 39.06946, y7: 39.80512, y8: 40.24538, y9: 40.675753 },
    { x: 3, l: 1, m: 39.5328, s: 0.0314, y1: 37.05014, y2: 37.49099, y3: 37.94197, y4: 38.69554, y5: 39.5328, y6: 40.37006, y7: 41.12363, y8: 41.57461, y9: 42.01546 },
    { x: 4, l: 1, m: 40.5817, s: 0.03119, y1: 38.05021, y2: 38.49974, y3: 38.95958, y4: 39.72797, y5: 40.5817, y6: 41.43543, y7: 42.20382, y8: 42.66366, y9: 43.113186 },
    { x: 5, l: 1, m: 41.459, s: 0.03102, y1: 38.88688, y2: 39.34362, y3: 39.81085, y4: 40.59157, y5: 41.459, y6: 42.32643, y7: 43.10715, y8: 43.57438, y9: 44.031116 },
    { x: 6, l: 1, m: 42.1995, s: 0.03087, y1: 39.5941, y2: 40.05675, y3: 40.53002, y4: 41.32084, y5: 42.1995, y6: 43.07816, y7: 43.86898, y8: 44.34225, y9: 44.804897 },
    { x: 7, l: 1, m: 42.829, s: 0.03075, y1: 40.19502, y2: 40.66274, y3: 41.14121, y4: 41.9407, y5: 42.829, y6: 43.7173, y7: 44.51679, y8: 44.99526, y9: 45.462984 },
    { x: 8, l: 1, m: 43.3671, s: 0.03063, y1: 40.71043, y2: 41.18218, y3: 41.66477, y4: 42.47115, y5: 43.3671, y6: 44.26305, y7: 45.06943, y8: 45.55202, y9: 46.023769 },
    { x: 9, l: 1, m: 43.83, s: 0.03053, y1: 41.15374, y2: 41.62897, y3: 42.11512, y4: 42.92745, y5: 43.83, y6: 44.73255, y7: 45.54488, y8: 46.03103, y9: 46.50626 },
    { x: 10, l: 1, m: 44.2319, s: 0.03044, y1: 41.53906, y2: 42.01724, y3: 42.50639, y4: 43.32375, y5: 44.2319, y6: 45.14005, y7: 45.95741, y8: 46.44656, y9: 46.924738 },
    { x: 11, l: 1, m: 44.5844, s: 0.03035, y1: 41.87813, y2: 42.35869, y3: 42.85029, y4: 43.67172, y5: 44.5844, y6: 45.49708, y7: 46.31851, y8: 46.81011, y9: 47.290673 },
    { x: 12, l: 1, m: 44.8965, s: 0.03027, y1: 42.17847, y2: 42.66112, y3: 43.15485, y4: 43.97986, y5: 44.8965, y6: 45.81314, y7: 46.63815, y8: 47.13188, y9: 47.614534 },
    { x: 13, l: 1, m: 45.1752, s: 0.03019, y1: 42.44752, y2: 42.93188, y3: 43.42737, y4: 44.2553, y5: 45.1752, y6: 46.0951, y7: 46.92303, y8: 47.41852, y9: 47.902879 },
    { x: 14, l: 1, m: 45.4265, s: 0.03012, y1: 42.69001, y2: 43.17594, y3: 43.67302, y4: 44.50363, y5: 45.4265, y6: 46.34937, y7: 47.17998, y8: 47.67706, y9: 48.162992 },
    { x: 15, l: 1, m: 45.6551, s: 0.03006, y1: 42.91032, y2: 43.39772, y3: 43.89631, y4: 44.72944, y5: 45.6551, y6: 46.58076, y7: 47.41389, y8: 47.91248, y9: 48.399885 },
    { x: 16, l: 1, m: 45.865, s: 0.02999, y1: 43.11402, y2: 43.60252, y3: 44.10224, y4: 44.93725, y5: 45.865, y6: 46.79275, y7: 47.62776, y8: 48.12748, y9: 48.615983 },
    { x: 17, l: 1, m: 46.0598, s: 0.02993, y1: 43.30266, y2: 43.79225, y3: 44.29309, y4: 45.12997, y5: 46.0598, y6: 46.98963, y7: 47.82651, y8: 48.32735, y9: 48.81694 },
    { x: 18, l: 1, m: 46.2424, s: 0.02987, y1: 43.47988, y2: 43.97043, y3: 44.47224, y4: 45.31075, y5: 46.2424, y6: 47.17405, y7: 48.01256, y8: 48.51437, y9: 49.004921 },
    { x: 19, l: 1, m: 46.4152, s: 0.02982, y1: 43.647, y2: 44.13856, y3: 44.6414, y4: 45.48164, y5: 46.4152, y6: 47.34876, y7: 48.189, y8: 48.69184, y9: 49.183403 },
    { x: 20, l: 1, m: 46.5801, s: 0.02977, y1: 43.80672, y2: 44.2992, y3: 44.80299, y4: 45.64479, y5: 46.5801, y6: 47.51541, y7: 48.35721, y8: 48.861, y9: 49.353479 },
    { x: 21, l: 1, m: 46.7384, s: 0.02972, y1: 43.96027, y2: 44.45359, y3: 44.95824, y4: 45.80149, y5: 46.7384, y6: 47.67531, y7: 48.51856, y8: 49.02321, y9: 49.516531 },
    { x: 22, l: 1, m: 46.8913, s: 0.02967, y1: 44.10877, y2: 44.60287, y3: 45.10832, y4: 45.95291, y5: 46.8913, y6: 47.82969, y7: 48.67428, y8: 49.17973, y9: 49.67383 },
    { x: 23, l: 1, m: 47.0391, s: 0.02962, y1: 44.2525, y2: 44.74733, y3: 45.25352, y4: 46.09933, y5: 47.0391, y6: 47.97887, y7: 48.82468, y8: 49.33087, y9: 49.825696 },
    { x: 24, l: 1, m: 47.1822, s: 0.02957, y1: 44.39184, y2: 44.88734, y3: 45.39421, y4: 46.24117, y5: 47.1822, y6: 48.12323, y7: 48.97019, y8: 49.47706, y9: 49.972555 }    
  ];

  export const boysWeightDataWHO: DataPoint[] = [
    { x: 0, l: 0.3487, m: 3.3464, s: 0.14602, y1: 2.459312, y2: 2.603994, y3: 2.757621, y4: 3.027282, y5: 3.3464, y6: 3.686659, y7: 4.011499, y8: 4.214527, y9: 4.419354 },
    { x: 1, l: 0.2297, m: 4.4709, s: 0.13395, y1: 3.39089, y2: 3.566165, y3: 3.752603, y4: 4.080792, y5: 4.4709, y6: 4.889123, y7: 5.290726, y8: 5.542933, y9: 5.798331 },
    { x: 2, l: 0.197, m: 5.5675, s: 0.12385, y1: 4.31889, y2: 4.522344, y3: 4.738362, y4: 5.117754, y5: 5.5675, y6: 6.048448, y7: 6.509323, y8: 6.798348, y9: 7.090758 },
    { x: 3, l: 0.1738, m: 6.3762, s: 0.11727, y1: 5.018434, y2: 5.240269, y3: 5.475519, y4: 5.888058, y5: 6.3762, y6: 6.897306, y7: 7.395936, y8: 7.708329, y9: 8.024169 },
    { x: 4, l: 0.1553, m: 7.0023, s: 0.11316, y1: 5.561377, y2: 5.797135, y3: 6.046988, y4: 6.484777, y5: 7.0023, y6: 7.554286, y7: 8.082087, y8: 8.412602, y9: 8.746662 },
    { x: 5, l: 0.1395, m: 7.5105, s: 0.1108, y1: 5.996672, y2: 6.244465, y3: 6.507016, y4: 6.966941, y5: 7.5105, y6: 8.090161, y7: 8.644384, y8: 8.991445, y9: 9.342238 },
    { x: 6, l: 0.1257, m: 7.934, s: 0.10958, y1: 6.352967, y2: 6.611702, y3: 6.885864, y4: 7.366195, y5: 7.934, y6: 8.539707, y7: 9.119041, y8: 9.481939, y9: 9.848832 },
    { x: 7, l: 0.1134, m: 8.297, s: 0.10902, y1: 6.653301, y2: 6.922131, y3: 7.207057, y4: 7.706413, y5: 8.297, y6: 8.927371, y7: 9.530656, y8: 9.908738, y9: 10.29113 },
    { x: 8, l: 0.1021, m: 8.6151, s: 0.10882, y1: 6.913126, y2: 7.19127, y3: 7.486158, y4: 8.003205, y5: 8.6151, y6: 9.268678, y7: 9.894622, y8: 10.28713, y9: 10.68428 },
    { x: 9, l: 0.0917, m: 8.9014, s: 0.10881, y1: 7.144822, y2: 7.431644, y3: 7.735837, y4: 8.26946, y5: 8.9014, y6: 9.5769, y7: 10.22433, y8: 10.63055, y9: 11.04177 },
    { x: 10, l: 0.082, m: 9.1649, s: 0.10891, y1: 7.356558, y2: 7.651572, y3: 7.964565, y4: 8.5139, y5: 9.1649, y6: 9.861313, y7: 10.5293, y8: 10.94868, y9: 11.37341 },
    { x: 11, l: 0.073, m: 9.4122, s: 0.10906, y1: 7.55441, y2: 7.857229, y3: 8.178615, y4: 8.742959, y5: 9.4122, y6: 10.12867, y7: 10.81641, y8: 11.24845, y9: 11.6862 },
    { x: 12, l: 0.0644, m: 9.6479, s: 0.10925, y1: 7.742219, y2: 8.052577, y3: 8.382077, y4: 8.960956, y5: 9.6479, y6: 10.38387, y7: 11.09087, y8: 11.53526, y9: 11.98574 },
    { x: 13, l: 0.0563, m: 9.8749, s: 0.10949, y1: 7.922091, y2: 8.239848, y3: 8.577324, y4: 9.170505, y5: 9.8749, y6: 10.63014, y7: 11.35618, y8: 11.81281, y9: 12.27589 },
    { x: 14, l: 0.0487, m: 10.0953, s: 0.10976, y1: 8.095984, y2: 8.421033, y3: 8.76637, y4: 9.373665, y5: 10.0953, y6: 10.86959, y7: 11.61449, y8: 12.08325, y9: 12.55884 },
    { x: 15, l: 0.0413, m: 10.3108, s: 0.11007, y1: 8.265127, y2: 8.597424, y3: 8.950586, y4: 9.571948, y5: 10.3108, y6: 11.10416, y7: 11.86797, y8: 12.34891, y9: 12.83707 },
    { x: 16, l: 0.0343, m: 10.5228, s: 0.11041, y1: 8.430734, y2: 8.770274, y3: 9.13126, y4: 9.7667, y5: 10.5228, y6: 11.33528, y7: 12.11808, y8: 12.61125, y9: 13.11206 },
    { x: 17, l: 0.0275, m: 10.7319, s: 0.11079, y1: 8.593128, y2: 8.939942, y3: 9.308795, y4: 9.958406, y5: 10.7319, y6: 11.5637, y7: 12.36571, y8: 12.87128, y9: 13.38491 },
    { x: 18, l: 0.0211, m: 10.9385, s: 0.11119, y1: 8.752902, y2: 9.107002, y3: 9.483736, y4: 10.14755, y5: 10.9385, y6: 11.7897, y7: 12.61101, y8: 13.12906, y9: 13.65558 },
    { x: 19, l: 0.0148, m: 11.143, s: 0.11164, y1: 8.909889, y2: 9.27136, y3: 9.656076, y4: 10.33431, y5: 11.143, y6: 12.01396, y7: 12.855, y8: 13.38579, y9: 13.92552 },
    { x: 20, l: 0.0087, m: 11.3462, s: 0.11211, y1: 9.065209, y2: 9.434095, y3: 9.826848, y4: 10.51961, y5: 11.3462, y6: 12.23713, y7: 13.09811, y8: 13.64181, y9: 14.19492 },
    { x: 21, l: 0.0029, m: 11.5486, s: 0.11261, y1: 9.219037, y2: 9.595435, y3: 9.996335, y4: 10.70383, y5: 11.5486, y6: 12.45983, y7: 13.3411, y8: 13.89795, y9: 14.46469 },
    { x: 22, l: -0.0028, m: 11.7504, s: 0.11314, y1: 9.371554, y2: 9.755556, y3: 10.16471, y4: 10.88716, y5: 11.7504, y6: 12.6823, y7: 13.58426, y8: 14.15453, y9: 14.7352 },
    { x: 23, l: -0.0083, m: 11.9514, s: 0.11369, y1: 9.522741, y2: 9.914417, y3: 10.33191, y4: 11.06946, y5: 11.9514, y6: 12.90424, y7: 13.82718, y8: 14.41108, y9: 15.0059 },
    { x: 24, l: -0.0137, m: 12.1515, s: 0.11426, y1: 9.672527, y2: 10.07194, y3: 10.49784, y4: 11.25065, y5: 12.1515, y6: 13.12555, y7: 14.06979, y8: 14.66753, y9: 15.27674 }    
  ];

  export const girlsWeightDataWHO: DataPoint[] = [
    { x: 0, l: 0.3809, m: 3.2322, s: 0.14171, y1: 2.394672, y2: 2.532145, y3: 2.677725, y4: 2.932331, y5: 3.2322, y6: 3.55035, y7: 3.852667, y8: 4.040959, y9: 4.23043 },
    { x: 1, l: 0.1714, m: 4.1873, s: 0.13724, y1: 3.161067, y2: 3.326209, y3: 3.502477, y4: 3.814261, y5: 4.1873, y6: 4.590075, y7: 4.979539, y8: 5.225436, y9: 5.475454 },
    { x: 2, l: 0.0962, m: 5.1282, s: 0.13, y1: 3.941053, y2: 4.13172, y3: 4.335355, y4: 4.695944, y5: 5.1282, y6: 5.596104, y7: 6.049862, y8: 6.337067, y9: 6.629679 },
    { x: 3, l: 0.0402, m: 5.8458, s: 0.12619, y1: 4.53604, y2: 4.745935, y3: 4.970282, y4: 5.368044, y5: 5.8458, y6: 6.364222, y7: 6.868317, y8: 7.188096, y9: 7.51448 },
    { x: 4, l: -0.005, m: 6.4237, s: 0.12402, y1: 5.013368, y2: 5.238858, y3: 5.480078, y4: 5.90832, y5: 6.4237, y6: 6.984281, y7: 7.530756, y8: 7.87815, y9: 8.233311 },
    { x: 5, l: -0.043, m: 6.8985, s: 0.12274, y1: 5.403844, y2: 5.642267, y3: 5.897544, y4: 6.351329, y5: 6.8985, y6: 7.495018, y7: 8.077933, y8: 8.449225, y9: 8.829415 },
    { x: 6, l: -0.0756, m: 7.297, s: 0.12204, y1: 5.729383, y2: 5.97888, y3: 6.246243, y4: 6.72212, y5: 7.297, y6: 7.925102, y7: 8.540297, y8: 8.93289, y9: 9.335491 },
    { x: 7, l: -0.1039, m: 7.6422, s: 0.12178, y1: 6.008387, y2: 6.267836, y3: 6.546104, y4: 7.042017, y5: 7.6422, y6: 8.299352, y7: 8.94444, y8: 9.356859, y9: 9.780399 },
    { x: 8, l: -0.1288, m: 7.9487, s: 0.12181, y1: 6.253445, y2: 6.522061, y3: 6.810403, y4: 7.324907, y5: 7.9487, y6: 8.633118, y7: 9.306424, y8: 9.737639, y9: 10.181094 },
    { x: 9, l: -0.1507, m: 8.2254, s: 0.12199, y1: 6.472906, y2: 6.750018, y3: 7.047717, y4: 7.579535, y5: 8.2254, y6: 8.935413, y7: 9.63531, y8: 10.08429, y9: 10.546619 },
    { x: 10, l: -0.17, m: 8.48, s: 0.12223, y1: 6.673828, y2: 6.958886, y3: 7.265345, y4: 7.813398, y5: 8.48, y6: 9.214115, y7: 9.939115, y8: 10.4049, y9: 10.885105 },
    { x: 11, l: -0.1872, m: 8.7192, s: 0.12247, y1: 6.862262, y2: 7.15483, y3: 7.46957, y4: 8.032975, y5: 8.7192, y6: 9.476145, y7: 10.22495, y8: 10.7067, y9: 11.203888 },
    { x: 12, l: -0.2024, m: 8.9481, s: 0.12268, y1: 7.042612, y2: 7.342376, y3: 7.665043, y4: 8.24313, y5: 8.9481, y6: 9.726833, y7: 10.49835, y8: 10.99531, y9: 11.508699 },
    { x: 13, l: -0.2158, m: 9.1699, s: 0.12283, y1: 7.217847, y2: 7.524538, y3: 7.854825, y4: 8.446994, y5: 9.1699, y6: 9.969431, y7: 10.76258, y8: 11.27401, y9: 11.802811 },
    { x: 14, l: -0.2278, m: 9.387, s: 0.12294, y1: 7.389684, y2: 7.70313, y3: 8.040838, y4: 8.646697, y5: 9.387, y6: 10.20666, y7: 11.02071, y8: 11.54612, y9: 12.089777 },
    { x: 15, l: -0.2384, m: 9.6008, s: 0.12299, y1: 7.559527, y2: 7.879566, y3: 8.224501, y4: 8.843658, y5: 9.6008, y6: 10.43988, y7: 11.27403, y8: 11.81285, y9: 12.370737 },
    { x: 16, l: -0.2478, m: 9.8124, s: 0.12303, y1: 7.727588, y2: 8.054179, y3: 8.406286, y4: 9.038616, y5: 9.8124, y6: 10.67062, y7: 11.52454, y8: 12.07652, y9: 12.648367 },
    { x: 17, l: -0.2562, m: 10.0226, s: 0.12306, y1: 7.894535, y2: 8.227652, y3: 8.586898, y4: 9.232317, y5: 10.0226, y6: 10.89976, y7: 11.77319, y8: 12.33814, y9: 12.923724 },
    { x: 18, l: -0.2637, m: 10.2315, s: 0.12309, y1: 8.060311, y2: 8.399952, y3: 8.766325, y4: 9.424795, y5: 10.2315, y6: 11.12747, y7: 12.02024, y8: 12.59804, y9: 13.197211 },
    { x: 19, l: -0.2703, m: 10.4393, s: 0.12315, y1: 8.224599, y2: 8.570832, y3: 8.944403, y4: 9.616043, y5: 10.4393, y6: 11.3542, y7: 12.26642, y8: 12.85712, y9: 13.469923 },
    { x: 20, l: -0.2762, m: 10.6464, s: 0.12323, y1: 8.387882, y2: 8.74076, y3: 9.121584, y4: 9.806487, y5: 10.6464, y6: 11.58033, y7: 12.51209, y8: 13.11573, y9: 13.742203 },
    { x: 21, l: -0.2815, m: 10.8534, s: 0.12335, y1: 8.55031, y2: 8.909946, y3: 9.298148, y4: 9.996544, y5: 10.8534, y6: 11.80669, y7: 12.75831, y8: 13.37511, y9: 14.015488 },
    { x: 22, l: -0.2862, m: 11.0608, s: 0.1235, y1: 8.712397, y2: 9.078906, y3: 9.474611, y4: 10.18672, y5: 11.0608, y6: 12.03376, y7: 13.00554, y8: 13.6357, y9: 14.290176 },
    { x: 23, l: -0.2903, m: 11.2688, s: 0.12369, y1: 8.8741, y2: 9.247632, y3: 9.651002, y4: 10.37713, y5: 11.2688, y6: 12.26184, y7: 13.25422, y8: 13.89801, y9: 14.566876 },
    { x: 24, l: -0.2941, m: 11.4775, s: 0.1239, y1: 9.035869, y2: 9.416516, y3: 9.827655, y4: 10.56799, y5: 11.4775, y6: 12.49092, y7: 13.50419, y8: 14.16181, y9: 14.845286 }    
  ];

  export const boysHeadTriplets: ThreePoint[] = [
    {week: 23.0, value: 19, z: -1.102, p: 14 },
    {week: 23.0, value: 20, z: -0.332, p: 37 },
    {week: 23.0, value: 21, z: 0.432, p: 67 },
    {week: 23.3, value: 19, z: -1.452, p: 7 },
    {week: 23.3, value: 21, z: 0.072, p: 53 },
    {week: 23.3, value: 22, z: 0.832, p: 80 },
    {week: 24.0, value: 20, z: -1.1421, p: 13 },
    {week: 24.0, value: 22, z: 0.3621, p: 64 },
    {week: 24.0, value: 23, z: 1.1121, p: 87 },
    {week: 24.3, value: 20, z: -1.4822, p: 7 },
    {week: 24.3, value: 22, z: 0.0122, p: 51 },
    {week: 24.3, value: 23, z: 0.7622, p: 78 },
    {week: 25.0, value: 22, z: -0.4322, p: 33 },
    {week: 25.0, value: 23, z: 0.3022, p: 62 },
    {week: 25.0, value: 24, z: 1.0422, p: 85 },
    {week: 25.3, value: 22, z: -0.7523, p: 23 },
    {week: 25.3, value: 23, z: -0.0323, p: 49 },
    {week: 25.3, value: 24, z: 0.7023, p: 76 },
    {week: 26.0, value: 25, z: 0.9823, p: 84 },
    {week: 26.0, value: 26, z: 1.7023, p: 95 },
    {week: 26.0, value: 27, z: 2.4123, p: 99 },
    {week: 26.3, value: 25, z: 0.6624, p: 75 },
    {week: 26.3, value: 26, z: 1.3624, p: 91 },
    {week: 26.3, value: 27, z: 2.0724, p: 98 },
    {week: 27.0, value: 25, z: 0.2324, p: 59 },
    {week: 27.0, value: 26, z: 0.9224, p: 82 },
    {week: 27.0, value: 27, z: 1.6124, p: 95 },
    {week: 27.3, value: 25, z: -0.0925, p: 46 },
    {week: 27.3, value: 26, z: 0.5925, p: 72 },
    {week: 27.3, value: 27, z: 1.2725, p: 90 },
    {week: 28.0, value: 25, z: -0.5025, p: 31 },
    {week: 28.0, value: 26, z: 0.1725, p: 57 },
    {week: 28.0, value: 27, z: 0.8525, p: 80 },
    {week: 28.3, value: 26, z: -0.1326, p: 45 },
    {week: 28.3, value: 27, z: 0.5426, p: 71 },
    {week: 28.3, value: 28, z: 1.2126, p: 89 },
    {week: 29.0, value: 26, z: -0.5326, p: 30 },
    {week: 29.0, value: 27, z: 0.1426, p: 56 },
    {week: 29.0, value: 28, z: 0.8226, p: 79 },
    {week: 29.3, value: 27, z: -0.1527, p: 44 },
    {week: 29.3, value: 28, z: 0.5227, p: 70 },
    {week: 29.3, value: 29, z: 1.2027, p: 89 },
    {week: 30.0, value: 27, z: -0.5127, p: 30 },
    {week: 30.0, value: 28, z: 0.1627, p: 56 },
    {week: 30.0, value: 29, z: 0.8327, p: 80 },
    {week: 30.3, value: 27, z: -0.7728, p: 22 },
    {week: 30.3, value: 28, z: -0.1028, p: 46 },
    {week: 30.3, value: 29, z: 0.5628, p: 71 },
    {week: 31.0, value: 27, z: -1.1128, p: 13 },
    {week: 31.0, value: 28, z: -0.4628, p: 32 },
    {week: 31.0, value: 29, z: 0.2028, p: 58 },
    {week: 31.3, value: 29, z: -0.0829, p: 47 },
    {week: 31.3, value: 30, z: 0.5729, p: 72 },
    {week: 31.3, value: 31, z: 1.2229, p: 89 },
    {week: 32.0, value: 28, z: -1.0829, p: 14 },
    {week: 32.0, value: 29, z: -0.4329, p: 33 },
    {week: 32.0, value: 30, z: 0.2229, p: 59 },
    {week: 32.3, value: 29, z: -0.703, p: 24 },
    {week: 32.3, value: 30, z: -0.053, p: 48 },
    {week: 32.3, value: 31, z: 0.613, p: 73 },
    {week: 33.0, value: 30, z: -0.393, p: 35 },
    {week: 33.0, value: 31, z: 0.263, p: 60 },
    {week: 33.0, value: 32, z: 0.923, p: 82 },
    {week: 33.3, value: 29, z: -1.3131, p: 9 },
    {week: 33.3, value: 30, z: -0.6531, p: 26 },
    {week: 33.3, value: 31, z: 0.0131, p: 50 },
    {week: 34.0, value: 31, z: -0.3331, p: 37 },
    {week: 34.0, value: 32, z: 0.3431, p: 63 },
    {week: 34.0, value: 33, z: 1.0131, p: 84 },
    {week: 34.3, value: 31, z: -0.5931, p: 28 },
    {week: 34.3, value: 32, z: 0.0931, p: 54 },
    {week: 34.3, value: 33, z: 0.7731, p: 78 },
    {week: 35.0, value: 32, z: -0.2232, p: 41 },
    {week: 35.0, value: 33, z: 0.4632, p: 68 },
    {week: 35.0, value: 34, z: 1.1532, p: 87 },
    {week: 35.3, value: 31, z: -1.1432, p: 13 },
    {week: 35.3, value: 32, z: -0.4532, p: 33 },
    {week: 35.3, value: 33, z: 0.2432, p: 60 },
    {week: 36.0, value: 32, z: -0.7333, p: 23 },
    {week: 36.0, value: 33, z: -0.0333, p: 49 },
    {week: 36.0, value: 34, z: 0.6733, p: 75 },
    {week: 36.3, value: 33, z: -0.2233, p: 41 },
    {week: 36.3, value: 34, z: 0.4933, p: 69 },
    {week: 36.3, value: 35, z: 1.1933, p: 88 },
    {week: 37.0, value: 34, z: 0.2433, p: 59 },
    {week: 37.0, value: 35, z: 0.9633, p: 83 },
    {week: 37.0, value: 36, z: 1.6833, p: 95 },
    {week: 37.3, value: 33, z: -0.6733, p: 25 },
    {week: 37.3, value: 34, z: 0.0533, p: 52 },
    {week: 37.3, value: 35, z: 0.7833, p: 78 },
    {week: 38.0, value: 34, z: -0.1934, p: 42 },
    {week: 38.0, value: 35, z: 0.5434, p: 71 },
    {week: 38.0, value: 36, z: 1.2834, p: 90 },
    {week: 38.3, value: 34, z: -0.3834, p: 35 },
    {week: 38.3, value: 35, z: 0.3734, p: 64 },
    {week: 38.3, value: 36, z: 1.1134, p: 87 },
    {week: 39.0, value: 34, z: -0.6234, p: 27 },
    {week: 39.0, value: 35, z: 0.1334, p: 55 },
    {week: 39.0, value: 36, z: 0.8934, p: 81 },
    {week: 39.3, value: 34, z: -0.8035, p: 21 },
    {week: 39.3, value: 35, z: -0.0435, p: 48 },
    {week: 39.3, value: 36, z: 0.7235, p: 76 },
    {week: 40.0, value: 35, z: -0.2735, p: 39 },
    {week: 40.0, value: 36, z: 0.5035, p: 69 },
    {week: 40.0, value: 37, z: 1.2735, p: 90 },
    {week: 40.3, value: 35, z: -0.4535, p: 33 },
    {week: 40.3, value: 36, z: 0.3335, p: 63 },
    {week: 40.3, value: 37, z: 1.1135, p: 87 },
    {week: 41.0, value: 36, z: 0.1135, p: 54 },
    {week: 41.0, value: 37, z: 0.9035, p: 82 },
    {week: 41.0, value: 38, z: 1.6935, p: 95 },
    {week: 41.3, value: 35, z: -0.8536, p: 20 },
    {week: 41.3, value: 36, z: -0.0536, p: 48 },
    {week: 41.3, value: 37, z: 0.7536, p: 77 },
    {week: 42.0, value: 35, z: -1.0836, p: 14 },
    {week: 42.0, value: 36, z: -0.2736, p: 39 },
    {week: 42.0, value: 37, z: 0.5436, p: 70 },
    {week: 42.3, value: 36, z: -0.4436, p: 33 },
    {week: 42.3, value: 37, z: 0.3836, p: 65 },
    {week: 42.3, value: 38, z: 1.2036, p: 89 },
    {week: 43.0, value: 36, z: -0.6536, p: 26 },
    {week: 43.0, value: 37, z: 0.1836, p: 57 },
    {week: 43.0, value: 38, z: 1.0136, p: 84 },
    {week: 43.3, value: 36, z: -0.8237, p: 21 },
    {week: 43.3, value: 37, z: 0.0237, p: 51 },
    {week: 43.3, value: 38, z: 0.8637, p: 80 },
    {week: 44.0, value: 37, z: -0.1937, p: 43 },
    {week: 44.0, value: 38, z: 0.6637, p: 75 },
    {week: 44.0, value: 39, z: 1.5137, p: 93 },
    {week: 44.3, value: 37, z: -0.3437, p: 37 },
    {week: 44.3, value: 38, z: 0.5237, p: 70 },
    {week: 44.3, value: 39, z: 1.3737, p: 91 },
    {week: 45.0, value: 37, z: -0.5337, p: 30 },
    {week: 45.0, value: 38, z: 0.3237, p: 63 },
    {week: 45.0, value: 39, z: 1.1837, p: 88 },
    {week: 45.3, value: 37, z: -0.6837, p: 25 },
    {week: 45.3, value: 38, z: 0.1837, p: 57 },
    {week: 45.3, value: 39, z: 1.0437, p: 85 },
    {week: 46.0, value: 37, z: -0.8638, p: 19 },
    {week: 46.0, value: 38, z: -0.0138, p: 50 },
    {week: 46.0, value: 39, z: 0.8538, p: 80 },
    {week: 46.3, value: 37, z: -1.0038, p: 16 },
    {week: 46.3, value: 38, z: -0.1538, p: 44 },
    {week: 46.3, value: 39, z: 0.7138, p: 76 },
    {week: 47.0, value: 38, z: -0.3338, p: 37 },
    {week: 47.0, value: 39, z: 0.5338, p: 70 },
    {week: 47.0, value: 40, z: 1.3838, p: 92 },
    {week: 47.3, value: 38, z: -0.4638, p: 32 },
    {week: 47.3, value: 39, z: 0.3938, p: 65 },
    {week: 47.3, value: 40, z: 1.2538, p: 89 },
    {week: 48.0, value: 38, z: -0.6238, p: 27 },
    {week: 48.0, value: 39, z: 0.2338, p: 59 },
    {week: 48.0, value: 40, z: 1.0938, p: 86 },
    {week: 48.3, value: 38, z: -0.7438, p: 23 },
    {week: 48.3, value: 39, z: 0.1238, p: 55 },
    {week: 48.3, value: 40, z: 0.9738, p: 84 },
    {week: 49.0, value: 38, z: -0.8939, p: 19 },
    {week: 49.0, value: 39, z: -0.0439, p: 49 },
    {week: 49.0, value: 40, z: 0.8239, p: 79 },
    {week: 49.3, value: 38, z: -1.0239, p: 16 },
    {week: 49.3, value: 39, z: -0.1639, p: 44 },
    {week: 49.3, value: 40, z: 0.6939, p: 76 },
    {week: 50.0, value: 38, z: -1.2039, p: 12 },
    {week: 50.0, value: 39, z: -0.3439, p: 37 },
    {week: 50.0, value: 40, z: 0.5139, p: 70 },
  ]

  export const boysLengthTriplets: ThreePoint[] = [
    {week: 24.0, value: 29, z: -0.753, p: 23 },
    {week: 24.0, value: 31, z: 0.093, p: 53 },
    {week: 24.0, value: 33, z: 0.923, p: 82 },
    {week: 24.3, value: 29, z: -1.0031, p: 16 },
    {week: 24.3, value: 31, z: -0.1731, p: 43 },
    {week: 24.3, value: 33, z: 0.6631, p: 75 },
    {week: 25.0, value: 30, z: -0.9232, p: 18 },
    {week: 25.0, value: 32, z: -0.0932, p: 46 },
    {week: 25.0, value: 34, z: 0.7332, p: 77 },
    {week: 25.3, value: 31, z: -0.7532, p: 23 },
    {week: 25.3, value: 33, z: 0.0732, p: 53 },
    {week: 25.3, value: 35, z: 0.8932, p: 81 },
    {week: 26.0, value: 31, z: -1.0933, p: 14 },
    {week: 26.0, value: 34, z: 0.1433, p: 55 },
    {week: 26.0, value: 36, z: 0.9533, p: 83 },
    {week: 26.3, value: 32, z: -0.9334, p: 18 },
    {week: 26.3, value: 34, z: -0.1234, p: 45 },
    {week: 26.3, value: 36, z: 0.6934, p: 76 },
    {week: 27.0, value: 33, z: -0.8735, p: 19 },
    {week: 27.0, value: 35, z: -0.0635, p: 48 },
    {week: 27.0, value: 37, z: 0.7535, p: 77 },
    {week: 27.3, value: 34, z: -0.7235, p: 24 },
    {week: 27.3, value: 36, z: 0.0935, p: 53 },
    {week: 27.3, value: 38, z: 0.8935, p: 81 },
    {week: 28.0, value: 35, z: -0.6536, p: 26 },
    {week: 28.0, value: 37, z: 0.1536, p: 56 },
    {week: 28.0, value: 39, z: 0.9536, p: 83 },
    {week: 28.3, value: 35, z: -0.9037, p: 18 },
    {week: 28.3, value: 37, z: -0.1037, p: 46 },
    {week: 28.3, value: 39, z: 0.7037, p: 76 },
    {week: 29.0, value: 36, z: -0.8438, p: 20 },
    {week: 29.0, value: 38, z: -0.0338, p: 49 },
    {week: 29.0, value: 40, z: 0.7738, p: 78 },
    {week: 29.3, value: 37, z: -0.6838, p: 25 },
    {week: 29.3, value: 39, z: 0.1238, p: 55 },
    {week: 29.3, value: 41, z: 0.9238, p: 82 },
    {week: 30.0, value: 38, z: -0.6139, p: 27 },
    {week: 30.0, value: 40, z: 0.1939, p: 58 },
    {week: 30.0, value: 42, z: 0.9939, p: 84 },
    {week: 30.3, value: 38, z: -0.854, p: 20 },
    {week: 30.3, value: 40, z: -0.054, p: 48 },
    {week: 30.3, value: 42, z: 0.754, p: 77 },
    {week: 31.0, value: 39, z: -0.774, p: 22 },
    {week: 31.0, value: 41, z: 0.034, p: 51 },
    {week: 31.0, value: 43, z: 0.834, p: 80 },
    {week: 31.3, value: 40, z: -0.6141, p: 27 },
    {week: 31.3, value: 42, z: 0.2041, p: 58 },
    {week: 31.3, value: 44, z: 1.0041, p: 84 },
    {week: 32.0, value: 41, z: -0.5242, p: 30 },
    {week: 32.0, value: 43, z: 0.2942, p: 61 },
    {week: 32.0, value: 45, z: 1.1042, p: 86 },
    {week: 32.3, value: 41, z: -0.7542, p: 23 },
    {week: 32.3, value: 43, z: 0.0642, p: 52 },
    {week: 32.3, value: 45, z: 0.8742, p: 81 },
    {week: 33.0, value: 41, z: -1.0543, p: 15 },
    {week: 33.0, value: 43, z: -0.2443, p: 40 },
    {week: 33.0, value: 45, z: 0.5743, p: 72 },
    {week: 33.3, value: 42, z: -0.8744, p: 19 },
    {week: 33.3, value: 44, z: -0.0644, p: 48 },
    {week: 33.3, value: 46, z: 0.7544, p: 77 },
    {week: 34.0, value: 43, z: -0.7644, p: 22 },
    {week: 34.0, value: 45, z: 0.0544, p: 52 },
    {week: 34.0, value: 47, z: 0.8744, p: 81 },
    {week: 34.3, value: 44, z: -0.5745, p: 28 },
    {week: 34.3, value: 46, z: 0.2545, p: 60 },
    {week: 34.3, value: 48, z: 1.0745, p: 86 },
    {week: 35.0, value: 44, z: -0.8546, p: 20 },
    {week: 35.0, value: 46, z: -0.0346, p: 49 },
    {week: 35.0, value: 48, z: 0.7946, p: 79 },
    {week: 35.3, value: 45, z: -0.6546, p: 26 },
    {week: 35.3, value: 47, z: 0.1846, p: 57 },
    {week: 35.3, value: 49, z: 1.0146, p: 84 },
    {week: 36.0, value: 45, z: -0.9247, p: 18 },
    {week: 36.0, value: 47, z: -0.0947, p: 47 },
    {week: 36.0, value: 49, z: 0.7547, p: 77 },
    {week: 36.3, value: 46, z: -0.7047, p: 24 },
    {week: 36.3, value: 48, z: 0.1447, p: 55 },
    {week: 36.3, value: 50, z: 0.9747, p: 83 },
    {week: 37.0, value: 46, z: -0.9548, p: 17 },
    {week: 37.0, value: 48, z: -0.1148, p: 46 },
    {week: 37.0, value: 50, z: 0.7448, p: 77 },
    {week: 37.3, value: 47, z: -0.7148, p: 24 },
    {week: 37.3, value: 49, z: 0.1448, p: 56 },
    {week: 37.3, value: 51, z: 0.9948, p: 84 },
    {week: 38.0, value: 47, z: -0.9449, p: 17 },
    {week: 38.0, value: 49, z: -0.0949, p: 47 },
    {week: 38.0, value: 51, z: 0.7749, p: 78 },
    {week: 38.3, value: 48, z: -0.6949, p: 25 },
    {week: 38.3, value: 50, z: 0.1749, p: 57 },
    {week: 38.3, value: 52, z: 1.0349, p: 85 },
    {week: 39.0, value: 48, z: -0.925, p: 18 },
    {week: 39.0, value: 50, z: -0.055, p: 48 },
    {week: 39.0, value: 52, z: 0.825, p: 79 },
    {week: 39.3, value: 49, z: -0.655, p: 26 },
    {week: 39.3, value: 51, z: 0.225, p: 59 },
    {week: 39.3, value: 53, z: 1.095, p: 86 },
    {week: 40.0, value: 49, z: -0.8851, p: 19 },
    {week: 40.0, value: 51, z: 0.0051, p: 50 },
    {week: 40.0, value: 53, z: 0.8851, p: 81 },
    {week: 40.3, value: 50, z: -0.6151, p: 27 },
    {week: 40.3, value: 52, z: 0.2751, p: 61 },
    {week: 40.3, value: 54, z: 1.1651, p: 88 },
    {week: 41.0, value: 50, z: -0.8351, p: 20 },
    {week: 41.0, value: 52, z: 0.0651, p: 52 },
    {week: 41.0, value: 54, z: 0.9551, p: 83 },
    {week: 41.3, value: 50, z: -1.0052, p: 16 },
    {week: 41.3, value: 52, z: -0.1052, p: 46 },
    {week: 41.3, value: 54, z: 0.7952, p: 78 },
    {week: 42.0, value: 51, z: -0.7752, p: 22 },
    {week: 42.0, value: 53, z: 0.1352, p: 55 },
    {week: 42.0, value: 55, z: 1.0352, p: 85 },
    {week: 42.3, value: 51, z: -0.9453, p: 17 },
    {week: 42.3, value: 53, z: -0.0353, p: 49 },
    {week: 42.3, value: 55, z: 0.8753, p: 81 },
    {week: 43.0, value: 52, z: -0.7053, p: 24 },
    {week: 43.0, value: 54, z: 0.2153, p: 58 },
    {week: 43.0, value: 56, z: 1.1253, p: 87 },
    {week: 43.3, value: 52, z: -0.8753, p: 19 },
    {week: 43.3, value: 54, z: 0.0553, p: 52 },
    {week: 43.3, value: 56, z: 0.9653, p: 83 },
    {week: 44.0, value: 53, z: -0.6354, p: 27 },
    {week: 44.0, value: 55, z: 0.2954, p: 62 },
    {week: 44.0, value: 57, z: 1.2154, p: 89 },
    {week: 44.3, value: 53, z: -0.7954, p: 22 },
    {week: 44.3, value: 55, z: 0.1454, p: 55 },
    {week: 44.3, value: 57, z: 1.0654, p: 86 },
    {week: 45.0, value: 53, z: -1.0155, p: 16 },
    {week: 45.0, value: 55, z: -0.0855, p: 47 },
    {week: 45.0, value: 57, z: 0.8555, p: 80 },
    {week: 45.3, value: 54, z: -0.7255, p: 24 },
    {week: 45.3, value: 56, z: 0.2255, p: 59 },
    {week: 45.3, value: 58, z: 1.1555, p: 87 },
    {week: 46.0, value: 54, z: -0.9556, p: 17 },
    {week: 46.0, value: 57, z: 0.4656, p: 68 },
    {week: 46.0, value: 58, z: 0.9356, p: 82 },
    {week: 46.3, value: 55, z: -0.6556, p: 26 },
    {week: 46.3, value: 57, z: 0.2956, p: 61 },
    {week: 46.3, value: 59, z: 1.2456, p: 89 },
    {week: 47.0, value: 55, z: -0.8756, p: 19 },
    {week: 47.0, value: 57, z: 0.0856, p: 53 },
    {week: 47.0, value: 59, z: 1.0356, p: 85 },
    {week: 47.3, value: 55, z: -1.0357, p: 15 },
    {week: 47.3, value: 57, z: -0.0757, p: 47 },
    {week: 47.3, value: 59, z: 0.8857, p: 81 },
    {week: 48.0, value: 56, z: -0.7657, p: 22 },
    {week: 48.0, value: 58, z: 0.2057, p: 58 },
    {week: 48.0, value: 59, z: 0.6857, p: 75 },
    {week: 48.3, value: 56, z: -0.9257, p: 18 },
    {week: 48.3, value: 58, z: 0.0457, p: 52 },
    {week: 48.3, value: 59, z: 0.5257, p: 70 },
    {week: 49.0, value: 57, z: -0.6558, p: 26 },
    {week: 49.0, value: 58, z: -0.1758, p: 43 },
    {week: 49.0, value: 59, z: 0.3258, p: 62 },
    {week: 49.3, value: 57, z: -0.8158, p: 21 },
    {week: 49.3, value: 58, z: -0.3258, p: 37 },
    {week: 49.3, value: 59, z: 0.1758, p: 57 },
    {week: 50.0, value: 57, z: -1.0059, p: 16 },
    {week: 50.0, value: 58, z: -0.5159, p: 30 },
    {week: 50.0, value: 59, z: -0.0259, p: 49 }
  ]
  export const boysWeightTriplets: ThreePoint[] = [
    {week: 23.0, value: 490, z: -0.7755086, p: 22 },
    {week: 23.0, value: 540, z: -0.1355093, p: 45 },
    {week: 23.0, value: 600, z: 0.63550102, p: 74 },
    {week: 23.3, value: 520, z: -0.8459089, p: 20 },
    {week: 23.3, value: 600, z: 0.12590101, p: 55 },
    {week: 23.3, value: 670, z: 0.96590111, p: 83 },
    {week: 24.0, value: 570, z: -0.8364595, p: 20 },
    {week: 24.0, value: 640, z: -0.06645106, p: 48 },
    {week: 24.0, value: 730, z: 0.9464512, p: 83 },
    {week: 24.3, value: 610, z: -0.826891, p: 21 },
    {week: 24.3, value: 700, z: 0.11689115, p: 54 },
    {week: 24.3, value: 780, z: 0.95689127, p: 83 },
    {week: 25.0, value: 660, z: -0.88752106, p: 19 },
    {week: 25.0, value: 750, z: -0.02752121, p: 49 },
    {week: 25.0, value: 840, z: 0.85752135, p: 80 },
    {week: 25.3, value: 710, z: -0.8280311, p: 20 },
    {week: 25.3, value: 800, z: -0.02803125, p: 49 },
    {week: 25.3, value: 900, z: 0.89803141, p: 81 },
    {week: 26.0, value: 780, z: -0.76873116, p: 22 },
    {week: 26.0, value: 880, z: 0.06873132, p: 52 },
    {week: 26.0, value: 980, z: 0.89873148, p: 81 },
    {week: 26.3, value: 820, z: -0.83928118, p: 20 },
    {week: 26.3, value: 940, z: 0.09928136, p: 54 },
    {week: 26.3, value: 1060, z: 1.03928155, p: 85 },
    {week: 27.0, value: 890, z: -0.801004122, p: 21 },
    {week: 27.0, value: 1010, z: 0.041004138, p: 52 },
    {week: 27.0, value: 1130, z: 0.911004157, p: 82 },
    {week: 27.3, value: 930, z: -0.881062123, p: 19 },
    {week: 27.3, value: 1060, z: -0.021062139, p: 49 },
    {week: 27.3, value: 1180, z: 0.791062158, p: 79 },
    {week: 28.0, value: 1010, z: -0.821141129, p: 21 },
    {week: 28.0, value: 1150, z: 0.061141144, p: 52 },
    {week: 28.0, value: 1280, z: 0.861141165, p: 81 },
    {week: 28.3, value: 1060, z: -0.841201132, p: 20 },
    {week: 28.3, value: 1210, z: 0.051201148, p: 52 },
    {week: 28.3, value: 1360, z: 0.921201173, p: 82 },
    {week: 29.0, value: 1140, z: -0.811284139, p: 21 },
    {week: 29.0, value: 1290, z: 0.031284154, p: 51 },
    {week: 29.0, value: 1450, z: 0.891284179, p: 81 },
    {week: 29.3, value: 1190, z: -0.851348143, p: 20 },
    {week: 29.3, value: 1360, z: 0.061348161, p: 52 },
    {week: 29.3, value: 1520, z: 0.861348185, p: 81 },
    {week: 30.0, value: 1270, z: -0.85143715, p: 20 },
    {week: 30.0, value: 1440, z: 0.011437168, p: 51 },
    {week: 30.0, value: 1630, z: 0.891437196, p: 81 },
    {week: 30.3, value: 1340, z: -0.821507157, p: 21 },
    {week: 30.3, value: 1510, z: 0.011507176, p: 51 },
    {week: 30.3, value: 1690, z: 0.8015072, p: 79 },
    {week: 31.0, value: 1420, z: -0.861605165, p: 20 },
    {week: 31.0, value: 1610, z: 0.021605187, p: 51 },
    {week: 31.0, value: 1830, z: 0.901605214, p: 82 },
    {week: 31.3, value: 1490, z: -0.851683173, p: 20 },
    {week: 31.3, value: 1690, z: 0.031683195, p: 51 },
    {week: 31.3, value: 1910, z: 0.871683221, p: 81 },
    {week: 32.0, value: 1600, z: -0.791791185, p: 21 },
    {week: 32.0, value: 1800, z: 0.031791207, p: 51 },
    {week: 32.0, value: 2040, z: 0.891791233, p: 81 },
    {week: 32.3, value: 1670, z: -0.821877191, p: 21 },
    {week: 32.3, value: 1890, z: 0.051877215, p: 52 },
    {week: 32.3, value: 2130, z: 0.871877239, p: 81 },
    {week: 33.0, value: 1770, z: -0.851998199, p: 20 },
    {week: 33.0, value: 1990, z: -0.031998221, p: 49 },
    {week: 33.0, value: 2260, z: 0.851998246, p: 80 },
    {week: 33.3, value: 1870, z: -0.792091204, p: 22 },
    {week: 33.3, value: 2100, z: 0.032091227, p: 51 },
    {week: 33.3, value: 2370, z: 0.87209125, p: 81 },
    {week: 34.0, value: 1970, z: -0.842220206, p: 20 },
    {week: 34.0, value: 2230, z: 0.032220229, p: 51 },
    {week: 34.0, value: 2530, z: 0.922220253, p: 82 },
    {week: 34.3, value: 2070, z: -0.802317207, p: 21 },
    {week: 34.3, value: 2330, z: 0.042317229, p: 52 },
    {week: 34.3, value: 2620, z: 0.87231725, p: 81 },
    {week: 35.0, value: 2180, z: -0.832448204, p: 20 },
    {week: 35.0, value: 2460, z: 0.042448225, p: 51 },
    {week: 35.0, value: 2750, z: 0.832448246, p: 80 },
    {week: 35.3, value: 2260, z: -0.852545201, p: 20 },
    {week: 35.3, value: 2550, z: 0.012545222, p: 51 },
    {week: 35.3, value: 2860, z: 0.842545243, p: 80 },
    {week: 36.0, value: 2380, z: -0.842672199, p: 20 },
    {week: 36.0, value: 2680, z: 0.022672219, p: 51 },
    {week: 36.0, value: 3000, z: 0.842672239, p: 80 },
    {week: 36.3, value: 2480, z: -0.802766199, p: 21 },
    {week: 36.3, value: 2780, z: 0.042766218, p: 51 },
    {week: 36.3, value: 3100, z: 0.842766238, p: 80 },
    {week: 37.0, value: 2580, z: -0.842891198, p: 20 },
    {week: 37.0, value: 2900, z: 0.022891217, p: 51 },
    {week: 37.0, value: 3240, z: 0.852891238, p: 80 },
    {week: 37.3, value: 2660, z: -0.852984198, p: 20 },
    {week: 37.3, value: 2990, z: 0.022984217, p: 51 },
    {week: 37.3, value: 3340, z: 0.842984238, p: 80 },
    {week: 38.0, value: 2790, z: -0.813107199, p: 21 },
    {week: 38.0, value: 3120, z: 0.033107218, p: 51 },
    {week: 38.0, value: 3460, z: 0.813107237, p: 79 },
    {week: 38.3, value: 2860, z: -0.853201199, p: 20 },
    {week: 38.3, value: 3210, z: 0.023201218, p: 51 },
    {week: 38.3, value: 3560, z: 0.803201237, p: 79 },
    {week: 39.0, value: 2960, z: -0.883325198, p: 19 },
    {week: 39.0, value: 3340, z: 0.033325219, p: 51 },
    {week: 39.0, value: 3750, z: 0.923325241, p: 82 },
    {week: 39.3, value: 3060, z: -0.843419199, p: 20 },
    {week: 39.3, value: 3410, z: -0.023419218, p: 49 },
    {week: 39.3, value: 3800, z: 0.813419238, p: 79 },
    {week: 40.0, value: 3190, z: -0.803544201, p: 21 },
    {week: 40.0, value: 3530, z: -0.033544218, p: 49 },
    {week: 40.0, value: 4180, z: 1.27354425, p: 90 },
    {week: 40.3, value: 3260, z: -0.8436372, p: 20 },
    {week: 40.3, value: 3650, z: 0.03363722, p: 51 },
    {week: 40.3, value: 4180, z: 1.083637245, p: 86 },
    {week: 41.0, value: 3360, z: -0.873762199, p: 19 },
    {week: 41.0, value: 3790, z: 0.063762221, p: 52 },
    {week: 41.0, value: 4320, z: 1.083762245, p: 86 },
    {week: 41.3, value: 3460, z: -0.8438562, p: 20 },
    {week: 41.3, value: 3870, z: 0.03385622, p: 51 },
    {week: 41.3, value: 4380, z: 1.003856244, p: 84 },
    {week: 42.0, value: 3590, z: -0.813982201, p: 21 },
    {week: 42.0, value: 4010, z: 0.063982221, p: 52 },
    {week: 42.0, value: 4540, z: 1.033982245, p: 85 },
    {week: 42.3, value: 3660, z: -0.8440762, p: 20 },
    {week: 42.3, value: 4090, z: 0.03407622, p: 51 },
    {week: 42.3, value: 4600, z: 0.964076243, p: 83 },
    {week: 43.0, value: 3790, z: -0.814201201, p: 21 },
    {week: 43.0, value: 4230, z: 0.054201221, p: 52 },
    {week: 43.0, value: 4760, z: 0.994201244, p: 84 },
    {week: 43.3, value: 3860, z: -0.8442962, p: 20 },
    {week: 43.3, value: 4310, z: 0.03429622, p: 51 },
    {week: 43.3, value: 4840, z: 0.954296243, p: 83 },
    {week: 44.0, value: 4010, z: -0.774421201, p: 22 },
    {week: 44.0, value: 4450, z: 0.054421221, p: 52 },
    {week: 44.0, value: 5030, z: 1.034421245, p: 85 },
    {week: 44.3, value: 4060, z: -0.844515199, p: 20 },
    {week: 44.3, value: 4530, z: 0.03451522, p: 51 },
    {week: 44.3, value: 5060, z: 0.924515242, p: 82 },
    {week: 45.0, value: 4210, z: -0.774640201, p: 22 },
    {week: 45.0, value: 4670, z: 0.05464022, p: 52 },
    {week: 45.0, value: 5280, z: 1.044640245, p: 85 },
    {week: 45.3, value: 4350, z: -0.674734203, p: 25 },
    {week: 45.3, value: 4750, z: 0.03473422, p: 51 },
    {week: 45.3, value: 5380, z: 1.034734245, p: 85 },
    {week: 46.0, value: 4430, z: -0.744859201, p: 23 },
    {week: 46.0, value: 4890, z: 0.05485922, p: 52 },
    {week: 46.0, value: 5440, z: 0.924859241, p: 82 },
    {week: 46.3, value: 4570, z: -0.644953203, p: 26 },
    {week: 46.3, value: 5000, z: 0.08495322, p: 53 },
    {week: 46.3, value: 5660, z: 1.094953246, p: 86 },
    {week: 47.0, value: 4550, z: -0.885078198, p: 19 },
    {week: 47.0, value: 5110, z: 0.05507822, p: 52 },
    {week: 47.0, value: 5630, z: 0.845078239, p: 80 },
    {week: 47.3, value: 4590, z: -0.965172196, p: 17 },
    {week: 47.3, value: 5220, z: 0.08517222, p: 53 },
    {week: 47.3, value: 5810, z: 0.955172242, p: 83 },
    {week: 48.0, value: 4770, z: -0.845297198, p: 20 },
    {week: 48.0, value: 5330, z: 0.055297219, p: 52 },
    {week: 48.0, value: 5950, z: 0.955297242, p: 83 },
    {week: 48.3, value: 4810, z: -0.925390197, p: 18 },
    {week: 48.3, value: 5440, z: 0.07539022, p: 53 },
    {week: 48.3, value: 5970, z: 0.845390239, p: 80 },
    {week: 49.0, value: 4990, z: -0.815515199, p: 21 },
    {week: 49.0, value: 5550, z: 0.055515219, p: 52 },
    {week: 49.0, value: 6110, z: 0.845515239, p: 80 },
    {week: 49.3, value: 5030, z: -0.885608197, p: 19 },
    {week: 49.3, value: 5660, z: 0.07560822, p: 53 },
    {week: 49.3, value: 6240, z: 0.88560824, p: 81 },
    {week: 50.0, value: 5190, z: -0.815733199, p: 21 },
    {week: 50.0, value: 5750, z: 0.025733219, p: 51 },
    {week: 50.0, value: 6350, z: 0.845733239, p: 80 }
  ]
  export const girlsHeadTriplets: ThreePoint[] = [
    {week: 23.0, value: 19, z: -0.742, p: 23},
    {week: 23.0, value: 20, z: 0.022, p: 51},
    {week: 23.0, value: 21, z: 0.782, p: 78},
    {week: 23.3, value: 19, z: -1.082, p: 14},
    {week: 23.3, value: 20, z: -0.322, p: 37},
    {week: 23.3, value: 21, z: 0.442, p: 67},
    {week: 24.0, value: 20, z: -0.7921, p: 21},
    {week: 24.0, value: 21, z: -0.0321, p: 49},
    {week: 24.0, value: 22, z: 0.7321, p: 77},
    {week: 24.3, value: 21, z: -0.3821, p: 35},
    {week: 24.3, value: 22, z: 0.3821, p: 65},
    {week: 24.3, value: 23, z: 1.1421, p: 87},
    {week: 25.0, value: 21, z: -0.8422, p: 20},
    {week: 25.0, value: 22, z: -0.0822, p: 47},
    {week: 25.0, value: 23, z: 0.6722, p: 75},
    {week: 25.3, value: 22, z: -0.4222, p: 34},
    {week: 25.3, value: 23, z: 0.3322, p: 63},
    {week: 25.3, value: 24, z: 1.0822, p: 86},
    {week: 26.0, value: 23, z: -0.1223, p: 45},
    {week: 26.0, value: 24, z: 0.6223, p: 73},
    {week: 26.0, value: 25, z: 1.3623, p: 91},
    {week: 26.3, value: 23, z: -0.4523, p: 33},
    {week: 26.3, value: 24, z: 0.2823, p: 61},
    {week: 26.3, value: 25, z: 1.0123, p: 84},
    {week: 27.0, value: 23, z: -0.8724, p: 19},
    {week: 27.0, value: 24, z: -0.1524, p: 44},
    {week: 27.0, value: 25, z: 0.5624, p: 71},
    {week: 27.3, value: 24, z: -0.4724, p: 32},
    {week: 27.3, value: 25, z: 0.2424, p: 59},
    {week: 27.3, value: 26, z: 0.9524, p: 83},
    {week: 28.0, value: 24, z: -0.8825, p: 19},
    {week: 28.0, value: 25, z: -0.1825, p: 43},
    {week: 28.0, value: 26, z: 0.5225, p: 70},
    {week: 28.3, value: 25, z: -0.4925, p: 31},
    {week: 28.3, value: 26, z: 0.2025, p: 58},
    {week: 28.3, value: 27, z: 0.9025, p: 82},
    {week: 29.0, value: 25, z: -0.9126, p: 18},
    {week: 29.0, value: 26, z: -0.2226, p: 41},
    {week: 29.0, value: 27, z: 0.4826, p: 68},
    {week: 29.3, value: 26, z: -0.5226, p: 30},
    {week: 29.3, value: 27, z: 0.1726, p: 57},
    {week: 29.3, value: 28, z: 0.8626, p: 81},
    {week: 30.0, value: 26, z: -0.8927, p: 19},
    {week: 30.0, value: 27, z: -0.2027, p: 42},
    {week: 30.0, value: 28, z: 0.4927, p: 69},
    {week: 30.3, value: 27, z: -0.4727, p: 32},
    {week: 30.3, value: 28, z: 0.2227, p: 59},
    {week: 30.3, value: 29, z: 0.9027, p: 82},
    {week: 31.0, value: 27, z: -0.8428, p: 20},
    {week: 31.0, value: 28, z: -0.1628, p: 44},
    {week: 31.0, value: 29, z: 0.5128, p: 70},
    {week: 31.3, value: 27, z: -1.1228, p: 13},
    {week: 31.3, value: 28, z: -0.4428, p: 33},
    {week: 31.3, value: 29, z: 0.2328, p: 59},
    {week: 32.0, value: 28, z: -0.8129, p: 21},
    {week: 32.0, value: 29, z: -0.1329, p: 45},
    {week: 32.0, value: 30, z: 0.5429, p: 71},
    {week: 32.3, value: 28, z: -1.0829, p: 14},
    {week: 32.3, value: 29, z: -0.4029, p: 35},
    {week: 32.3, value: 30, z: 0.2829, p: 61},
    {week: 33.0, value: 29, z: -0.753, p: 23},
    {week: 33.0, value: 30, z: -0.073, p: 47},
    {week: 33.0, value: 31, z: 0.613, p: 73},
    {week: 33.3, value: 29, z: -1.013, p: 16},
    {week: 33.3, value: 30, z: -0.333, p: 37},
    {week: 33.3, value: 31, z: 0.353, p: 64},
    {week: 34.0, value: 30, z: -0.6731, p: 25},
    {week: 34.0, value: 31, z: 0.0231, p: 51},
    {week: 34.0, value: 32, z: 0.7131, p: 76},
    {week: 34.3, value: 30, z: -0.9231, p: 18},
    {week: 34.3, value: 31, z: -0.2331, p: 41},
    {week: 34.3, value: 32, z: 0.4731, p: 68},
    {week: 35.0, value: 31, z: -0.5531, p: 29},
    {week: 35.0, value: 32, z: 0.1531, p: 56},
    {week: 35.0, value: 33, z: 0.8531, p: 80},
    {week: 35.3, value: 31, z: -0.7932, p: 21},
    {week: 35.3, value: 32, z: -0.0932, p: 47},
    {week: 35.3, value: 33, z: 0.6232, p: 73},
    {week: 36.0, value: 31, z: -1.0932, p: 14},
    {week: 36.0, value: 32, z: -0.3832, p: 35},
    {week: 36.0, value: 33, z: 0.3332, p: 63},
    {week: 36.3, value: 32, z: -0.5932, p: 28},
    {week: 36.3, value: 33, z: 0.1332, p: 55},
    {week: 36.3, value: 34, z: 0.8532, p: 80},
    {week: 37.0, value: 32, z: -0.8533, p: 20},
    {week: 37.0, value: 33, z: -0.1233, p: 45},
    {week: 37.0, value: 34, z: 0.6133, p: 73},
    {week: 37.3, value: 32, z: -1.0433, p: 15},
    {week: 37.3, value: 33, z: -0.3033, p: 38},
    {week: 37.3, value: 34, z: 0.4433, p: 67},
    {week: 38.0, value: 33, z: -0.5433, p: 30},
    {week: 38.0, value: 34, z: 0.2133, p: 58},
    {week: 38.0, value: 35, z: 0.9633, p: 83},
    {week: 38.3, value: 33, z: -0.7133, p: 24},
    {week: 38.3, value: 34, z: 0.0533, p: 52},
    {week: 38.3, value: 35, z: 0.8033, p: 79},
    {week: 39.0, value: 33, z: -0.9334, p: 17},
    {week: 39.0, value: 34, z: -0.1734, p: 43},
    {week: 39.0, value: 35, z: 0.5934, p: 72},
    {week: 39.3, value: 34, z: -0.3434, p: 37},
    {week: 39.3, value: 35, z: 0.4334, p: 67},
    {week: 39.3, value: 36, z: 1.2034, p: 88},
    {week: 40.0, value: 34, z: -0.5534, p: 29},
    {week: 40.0, value: 35, z: 0.2234, p: 59},
    {week: 40.0, value: 36, z: 1.0034, p: 84},
    {week: 40.3, value: 34, z: -0.7234, p: 24},
    {week: 40.3, value: 35, z: 0.0734, p: 53},
    {week: 40.3, value: 36, z: 0.8534, p: 80},
    {week: 41.0, value: 34, z: -0.9335, p: 18},
    {week: 41.0, value: 35, z: -0.1435, p: 44},
    {week: 41.0, value: 36, z: 0.6535, p: 74},
    {week: 41.3, value: 35, z: -0.2935, p: 39},
    {week: 41.3, value: 36, z: 0.5135, p: 69},
    {week: 41.3, value: 37, z: 1.3035, p: 90},
    {week: 42.0, value: 35, z: -0.4935, p: 31},
    {week: 42.0, value: 36, z: 0.3135, p: 62},
    {week: 42.0, value: 37, z: 1.1235, p: 87},
    {week: 42.3, value: 35, z: -0.6435, p: 26},
    {week: 42.3, value: 36, z: 0.1735, p: 57},
    {week: 42.3, value: 37, z: 0.9835, p: 84},
    {week: 43.0, value: 35, z: -0.8436, p: 20},
    {week: 43.0, value: 36, z: -0.0336, p: 49},
    {week: 43.0, value: 37, z: 0.7936, p: 79},
    {week: 43.3, value: 36, z: -0.1736, p: 43},
    {week: 43.3, value: 37, z: 0.6536, p: 74},
    {week: 43.3, value: 38, z: 1.4736, p: 93},
    {week: 44.0, value: 36, z: -0.3636, p: 36},
    {week: 44.0, value: 37, z: 0.4736, p: 68},
    {week: 44.0, value: 38, z: 1.2936, p: 90},
    {week: 44.3, value: 35, z: -1.3236, p: 9},
    {week: 44.3, value: 36, z: -0.4936, p: 31},
    {week: 44.3, value: 37, z: 0.3336, p: 63},
    {week: 45.0, value: 36, z: -0.6736, p: 25},
    {week: 45.0, value: 37, z: 0.1536, p: 56},
    {week: 45.0, value: 38, z: 0.9836, p: 84},
    {week: 45.3, value: 35, z: -1.6337, p: 5},
    {week: 45.3, value: 36, z: -0.8137, p: 21},
    {week: 45.3, value: 37, z: 0.0237, p: 51},
    {week: 46.0, value: 36, z: -0.9837, p: 16},
    {week: 46.0, value: 37, z: -0.1537, p: 44},
    {week: 46.0, value: 38, z: 0.6737, p: 75},
    {week: 46.3, value: 36, z: -1.1237, p: 13},
    {week: 46.3, value: 37, z: -0.2937, p: 39},
    {week: 46.3, value: 38, z: 0.5437, p: 71},
    {week: 47.0, value: 37, z: -0.4737, p: 32},
    {week: 47.0, value: 38, z: 0.3637, p: 64},
    {week: 47.0, value: 39, z: 1.1937, p: 88},
    {week: 47.3, value: 37, z: -0.6037, p: 27},
    {week: 47.3, value: 38, z: 0.2337, p: 59},
    {week: 47.3, value: 39, z: 1.0637, p: 86},
    {week: 48.0, value: 37, z: -0.7837, p: 22},
    {week: 48.0, value: 38, z: 0.0637, p: 52},
    {week: 48.0, value: 39, z: 0.9037, p: 82},
    {week: 48.3, value: 37, z: -0.9038, p: 18},
    {week: 48.3, value: 38, z: -0.0638, p: 48},
    {week: 48.3, value: 39, z: 0.7838, p: 78},
    {week: 49.0, value: 37, z: -1.0538, p: 15},
    {week: 49.0, value: 38, z: -0.2138, p: 42},
    {week: 49.0, value: 39, z: 0.6338, p: 74},
    {week: 49.3, value: 37, z: -1.1538, p: 13},
    {week: 49.3, value: 38, z: -0.3138, p: 38},
    {week: 49.3, value: 39, z: 0.5238, p: 70},
    {week: 50.0, value: 37, z: -1.2638, p: 10},
    {week: 50.0, value: 38, z: -0.4438, p: 33},
    {week: 50.0, value: 39, z: 0.3938, p: 65}
  ]
  export const girlsLengthTriplets: ThreePoint[] = [
    {week: 24.0, value: 29, z: -0.523, p: 30 },
    {week: 24.0, value: 30, z: -0.093, p: 47 },
    {week: 24.0, value: 31, z: 0.353, p: 64 },
    {week: 24.3, value: 29, z: -0.783, p: 22 },
    {week: 24.3, value: 31, z: 0.093, p: 54 },
    {week: 24.3, value: 33, z: 0.953, p: 83 },
    {week: 25.0, value: 29, z: -1.1131, p: 13 },
    {week: 25.0, value: 31, z: -0.2531, p: 40 },
    {week: 25.0, value: 33, z: 0.6031, p: 73 },
    {week: 25.3, value: 30, z: -0.9432, p: 17 },
    {week: 25.3, value: 32, z: -0.0832, p: 47 },
    {week: 25.3, value: 34, z: 0.7732, p: 78 },
    {week: 26.0, value: 31, z: -0.8533, p: 20 },
    {week: 26.0, value: 33, z: -0.0133, p: 50 },
    {week: 26.0, value: 35, z: 0.8433, p: 80 },
    {week: 26.3, value: 32, z: -0.6933, p: 25 },
    {week: 26.3, value: 34, z: 0.1633, p: 56 },
    {week: 26.3, value: 36, z: 1.0033, p: 84 },
    {week: 27.0, value: 33, z: -0.6134, p: 27 },
    {week: 27.0, value: 35, z: 0.2334, p: 59 },
    {week: 27.0, value: 37, z: 1.0734, p: 86 },
    {week: 27.3, value: 33, z: -0.8735, p: 19 },
    {week: 27.3, value: 35, z: -0.0335, p: 49 },
    {week: 27.3, value: 37, z: 0.8035, p: 79 },
    {week: 28.0, value: 34, z: -0.8035, p: 21 },
    {week: 28.0, value: 36, z: 0.0335, p: 51 },
    {week: 28.0, value: 38, z: 0.8735, p: 81 },
    {week: 28.3, value: 35, z: -0.6436, p: 26 },
    {week: 28.3, value: 37, z: 0.1936, p: 58 },
    {week: 28.3, value: 39, z: 1.0236, p: 85 },
    {week: 29.0, value: 35, z: -0.9837, p: 16 },
    {week: 29.0, value: 37, z: -0.1537, p: 44 },
    {week: 29.0, value: 39, z: 0.6837, p: 75 },
    {week: 29.3, value: 35, z: -1.2338, p: 11 },
    {week: 29.3, value: 38, z: 0.0138, p: 50 },
    {week: 29.3, value: 40, z: 0.8438, p: 80 },
    {week: 30.0, value: 37, z: -0.7438, p: 23 },
    {week: 30.0, value: 39, z: 0.0838, p: 53 },
    {week: 30.0, value: 41, z: 0.9138, p: 82 },
    {week: 30.3, value: 38, z: -0.5839, p: 28 },
    {week: 30.3, value: 40, z: 0.2439, p: 60 },
    {week: 30.3, value: 42, z: 1.0739, p: 86 },
    {week: 31.0, value: 39, z: -0.504, p: 31 },
    {week: 31.0, value: 41, z: 0.334, p: 63 },
    {week: 31.0, value: 43, z: 1.154, p: 88 },
    {week: 31.3, value: 38, z: -1.154, p: 12 },
    {week: 31.3, value: 40, z: -0.334, p: 37 },
    {week: 31.3, value: 42, z: 0.504, p: 69 },
    {week: 32.0, value: 40, z: -0.6441, p: 26 },
    {week: 32.0, value: 42, z: 0.1941, p: 57 },
    {week: 32.0, value: 44, z: 1.0141, p: 84 },
    {week: 32.3, value: 40, z: -0.8742, p: 19 },
    {week: 32.3, value: 42, z: -0.0442, p: 48 },
    {week: 32.3, value: 44, z: 0.7842, p: 78 },
    {week: 33.0, value: 41, z: -0.7542, p: 23 },
    {week: 33.0, value: 43, z: 0.0842, p: 53 },
    {week: 33.0, value: 45, z: 0.9142, p: 82 },
    {week: 33.3, value: 42, z: -0.5643, p: 29 },
    {week: 33.3, value: 44, z: 0.2843, p: 61 },
    {week: 33.3, value: 46, z: 1.1143, p: 87 },
    {week: 34.0, value: 42, z: -0.8644, p: 19 },
    {week: 34.0, value: 43, z: -0.4444, p: 33 },
    {week: 34.0, value: 45, z: 0.3944, p: 65 },
    {week: 34.3, value: 42, z: -1.0944, p: 14 },
    {week: 34.3, value: 44, z: -0.2544, p: 40 },
    {week: 34.3, value: 46, z: 0.5844, p: 72 },
    {week: 35.0, value: 43, z: -0.9745, p: 17 },
    {week: 35.0, value: 45, z: -0.1345, p: 45 },
    {week: 35.0, value: 47, z: 0.7145, p: 76 },
    {week: 35.3, value: 43, z: -1.1845, p: 12 },
    {week: 35.3, value: 45, z: -0.3445, p: 37 },
    {week: 35.3, value: 47, z: 0.5145, p: 69 },
    {week: 36.0, value: 45, z: -0.6146, p: 27 },
    {week: 36.0, value: 46, z: -0.1946, p: 43 },
    {week: 36.0, value: 48, z: 0.6646, p: 74 },
    {week: 36.3, value: 45, z: -0.8146, p: 21 },
    {week: 36.3, value: 47, z: 0.0446, p: 52 },
    {week: 36.3, value: 49, z: 0.8946, p: 81 },
    {week: 37.0, value: 46, z: -0.6447, p: 26 },
    {week: 37.0, value: 48, z: 0.2147, p: 58 },
    {week: 37.0, value: 50, z: 1.0747, p: 86 },
    {week: 37.3, value: 45, z: -1.2547, p: 10 },
    {week: 37.3, value: 48, z: 0.0347, p: 51 },
    {week: 37.3, value: 50, z: 0.8947, p: 81 },
    {week: 38.0, value: 47, z: -0.6348, p: 26 },
    {week: 38.0, value: 49, z: 0.2448, p: 59 },
    {week: 38.0, value: 51, z: 1.1048, p: 86 },
    {week: 38.3, value: 46, z: -1.2348, p: 11 },
    {week: 38.3, value: 48, z: -0.3748, p: 36 },
    {week: 38.3, value: 50, z: 0.5048, p: 69 },
    {week: 39.0, value: 48, z: -0.5949, p: 28 },
    {week: 39.0, value: 50, z: 0.2949, p: 61 },
    {week: 39.0, value: 52, z: 1.1649, p: 88 },
    {week: 39.3, value: 47, z: -1.1949, p: 12 },
    {week: 39.3, value: 50, z: 0.1349, p: 55 },
    {week: 39.3, value: 53, z: 1.4449, p: 93 },
    {week: 40.0, value: 48, z: -0.975, p: 17 },
    {week: 40.0, value: 50, z: -0.085, p: 47 },
    {week: 40.0, value: 52, z: 0.805, p: 79 },
    {week: 40.3, value: 49, z: -0.695, p: 25 },
    {week: 40.3, value: 51, z: 0.205, p: 58 },
    {week: 40.3, value: 53, z: 1.095, p: 86 },
    {week: 41.0, value: 50, z: -0.4651, p: 32 },
    {week: 41.0, value: 51, z: -0.0151, p: 50 },
    {week: 41.0, value: 53, z: 0.8851, p: 81 },
    {week: 41.3, value: 50, z: -0.6251, p: 27 },
    {week: 41.3, value: 52, z: 0.2851, p: 61 },
    {week: 41.3, value: 54, z: 1.1751, p: 88 },
    {week: 42.0, value: 50, z: -0.8351, p: 20 },
    {week: 42.0, value: 52, z: 0.0751, p: 53 },
    {week: 42.0, value: 54, z: 0.9751, p: 83 },
    {week: 42.3, value: 51, z: -0.5452, p: 29 },
    {week: 42.3, value: 53, z: 0.3652, p: 64 },
    {week: 42.3, value: 54, z: 0.8252, p: 79 },
    {week: 43.0, value: 50, z: -1.2152, p: 11 },
    {week: 43.0, value: 52, z: -0.3052, p: 38 },
    {week: 43.0, value: 54, z: 0.6152, p: 73 },
    {week: 43.3, value: 51, z: -0.9153, p: 18 },
    {week: 43.3, value: 53, z: 0.0053, p: 50 },
    {week: 43.3, value: 55, z: 0.9153, p: 82 },
    {week: 44.0, value: 51, z: -1.1253, p: 13 },
    {week: 44.0, value: 53, z: -0.2053, p: 42 },
    {week: 44.0, value: 55, z: 0.7153, p: 76 },
    {week: 44.3, value: 51, z: -1.2753, p: 10 },
    {week: 44.3, value: 54, z: 0.1053, p: 54 },
    {week: 44.3, value: 56, z: 1.0253, p: 85 },
    {week: 45.0, value: 53, z: -0.5554, p: 29 },
    {week: 45.0, value: 55, z: 0.3754, p: 64 },
    {week: 45.0, value: 57, z: 1.2954, p: 90 },
    {week: 45.3, value: 52, z: -1.1754, p: 12 },
    {week: 45.3, value: 54, z: -0.2454, p: 41 },
    {week: 45.3, value: 56, z: 0.6954, p: 75 },
    {week: 46.0, value: 53, z: -0.8954, p: 19 },
    {week: 46.0, value: 55, z: 0.0454, p: 52 },
    {week: 46.0, value: 57, z: 0.9754, p: 83 },
    {week: 46.3, value: 54, z: -0.5755, p: 29 },
    {week: 46.3, value: 55, z: -0.1055, p: 46 },
    {week: 46.3, value: 56, z: 0.3755, p: 64 },
    {week: 47.0, value: 54, z: -0.7555, p: 23 },
    {week: 47.0, value: 56, z: 0.1955, p: 57 },
    {week: 47.0, value: 58, z: 1.1355, p: 87 },
    {week: 47.3, value: 54, z: -0.9055, p: 19 },
    {week: 47.3, value: 56, z: 0.0555, p: 52 },
    {week: 47.3, value: 58, z: 0.9955, p: 84 },
    {week: 48.0, value: 55, z: -0.6256, p: 27 },
    {week: 48.0, value: 57, z: 0.3356, p: 63 },
    {week: 48.0, value: 59, z: 1.2756, p: 90 },
    {week: 48.3, value: 55, z: -0.7756, p: 22 },
    {week: 48.3, value: 57, z: 0.1856, p: 57 },
    {week: 48.3, value: 59, z: 1.1356, p: 87 },
    {week: 49.0, value: 56, z: -0.4957, p: 31 },
    {week: 49.0, value: 57, z: -0.0157, p: 50 },
    {week: 49.0, value: 58, z: 0.4757, p: 68 },
    {week: 49.3, value: 55, z: -1.1057, p: 14 },
    {week: 49.3, value: 57, z: -0.1457, p: 44 },
    {week: 49.3, value: 59, z: 0.8257, p: 79 },
    {week: 50.0, value: 56, z: -0.7857, p: 22 },
    {week: 50.0, value: 57, z: -0.3057, p: 38 },
    {week: 50.0, value: 58, z: 0.1957, p: 57 }
  ]
  export const girlsWeightTriplets: ThreePoint[] = [
    {week: 23.0, value: 440, z: -1.0951477, p: 14 },
    {week: 23.0, value: 500, z: -0.2051489, p: 42 },
    {week: 23.0, value: 560, z: 0.6351499, p: 74 },
    {week: 23.3, value: 470, z: -1.125528, p: 13 },
    {week: 23.3, value: 550, z: -0.0355295, p: 49 },
    {week: 23.3, value: 600, z: 0.61552103, p: 73 },
    {week: 24.0, value: 510, z: -1.1860585, p: 12 },
    {week: 24.0, value: 610, z: 0.05605103, p: 52 },
    {week: 24.0, value: 660, z: 0.64605112, p: 74 },
    {week: 24.3, value: 550, z: -1.1264891, p: 13 },
    {week: 24.3, value: 650, z: 0.03648109, p: 51 },
    {week: 24.3, value: 700, z: 0.58648117, p: 72 },
    {week: 25.0, value: 600, z: -1.1370897, p: 13 },
    {week: 25.0, value: 700, z: -0.08708114, p: 47 },
    {week: 25.0, value: 770, z: 0.63708126, p: 73 },
    {week: 25.3, value: 660, z: -0.93756104, p: 18 },
    {week: 25.3, value: 760, z: 0.04756121, p: 51 },
    {week: 25.3, value: 830, z: 0.70756132, p: 76 },
    {week: 26.0, value: 720, z: -0.92824108, p: 18 },
    {week: 26.0, value: 830, z: 0.06824126, p: 52 },
    {week: 26.0, value: 900, z: 0.66824137, p: 75 },
    {week: 26.3, value: 750, z: -1.05876108, p: 15 },
    {week: 26.3, value: 880, z: 0.03876128, p: 51 },
    {week: 26.3, value: 1020, z: 1.1787615, p: 88 },
    {week: 27.0, value: 840, z: -0.83948115, p: 20 },
    {week: 27.0, value: 960, z: 0.09948132, p: 53 },
    {week: 27.0, value: 1070, z: 0.91948149, p: 82 },
    {week: 27.3, value: 870, z: -0.961004114, p: 17 },
    {week: 27.3, value: 1000, z: -0.031004132, p: 49 },
    {week: 27.3, value: 1110, z: 0.751004148, p: 77 },
    {week: 28.0, value: 960, z: -0.791079121, p: 21 },
    {week: 28.0, value: 1070, z: -0.061079136, p: 48 },
    {week: 28.0, value: 1220, z: 0.921079159, p: 82 },
    {week: 28.3, value: 980, z: -0.991136122, p: 16 },
    {week: 28.3, value: 1130, z: -0.041136141, p: 48 },
    {week: 28.3, value: 1240, z: 0.641136157, p: 74 },
    {week: 29.0, value: 1070, z: -0.861215132, p: 19 },
    {week: 29.0, value: 1220, z: 0.03121515, p: 51 },
    {week: 29.0, value: 1330, z: 0.651215167, p: 74 },
    {week: 29.3, value: 1120, z: -0.891278137, p: 19 },
    {week: 29.3, value: 1280, z: 0.011278158, p: 51 },
    {week: 29.3, value: 1440, z: 0.861278182, p: 81 },
    {week: 30.0, value: 1210, z: -0.811365149, p: 21 },
    {week: 30.0, value: 1380, z: 0.071365171, p: 53 },
    {week: 30.0, value: 1590, z: 1.091365204, p: 86 },
    {week: 30.3, value: 1240, z: -0.981435152, p: 16 },
    {week: 30.3, value: 1460, z: 0.121435182, p: 55 },
    {week: 30.3, value: 1570, z: 0.631435198, p: 73 },
    {week: 31.0, value: 1360, z: -0.811534166, p: 21 },
    {week: 31.0, value: 1550, z: 0.071534191, p: 53 },
    {week: 31.0, value: 1710, z: 0.751534213, p: 77 },
    {week: 31.3, value: 1430, z: -0.801613172, p: 21 },
    {week: 31.3, value: 1600, z: -0.051613194, p: 48 },
    {week: 31.3, value: 1750, z: 0.561613214, p: 71 },
    {week: 32.0, value: 1510, z: -0.881723178, p: 19 },
    {week: 32.0, value: 1710, z: -0.051723202, p: 48 },
    {week: 32.0, value: 2060, z: 1.221723244, p: 89 },
    {week: 32.3, value: 1550, z: -1.021809179, p: 15 },
    {week: 32.3, value: 1800, z: -0.031809207, p: 49 },
    {week: 32.3, value: 2090, z: 0.991809238, p: 84 },
    {week: 33.0, value: 1790, z: -0.491926199, p: 31 },
    {week: 33.0, value: 1970, z: 0.151926217, p: 56 },
    {week: 33.0, value: 2240, z: 1.031926243, p: 85 },
    {week: 33.3, value: 1740, z: -0.98201619, p: 16 },
    {week: 33.3, value: 2030, z: 0.052016217, p: 52 },
    {week: 33.3, value: 2300, z: 0.902016241, p: 82 },
    {week: 34.0, value: 1850, z: -0.972139193, p: 17 },
    {week: 34.0, value: 2150, z: 0.03213922, p: 51 },
    {week: 34.0, value: 2360, z: 0.682139237, p: 75 },
    {week: 34.3, value: 1900, z: -1.082232192, p: 14 },
    {week: 34.3, value: 2240, z: 0.022232221, p: 51 },
    {week: 34.3, value: 2590, z: 1.042232248, p: 85 },
    {week: 35.0, value: 2050, z: -0.952358196, p: 17 },
    {week: 35.0, value: 2370, z: 0.042358221, p: 51 },
    {week: 35.0, value: 2660, z: 0.852358243, p: 80 },
    {week: 35.3, value: 2160, z: -0.872452198, p: 19 },
    {week: 35.3, value: 2460, z: 0.022452221, p: 51 },
    {week: 35.3, value: 2760, z: 0.842452244, p: 80 },
    {week: 36.0, value: 2230, z: -1.002578193, p: 16 },
    {week: 36.0, value: 2590, z: 0.032578219, p: 51 },
    {week: 36.0, value: 2930, z: 0.912578247, p: 82 },
    {week: 36.3, value: 2370, z: -0.832672194, p: 20 },
    {week: 36.3, value: 2680, z: 0.022672217, p: 51 },
    {week: 36.3, value: 2990, z: 0.802672243, p: 79 },
    {week: 37.0, value: 2480, z: -0.842797191, p: 20 },
    {week: 37.0, value: 2810, z: 0.032797214, p: 51 },
    {week: 37.0, value: 3160, z: 0.872797244, p: 81 },
    {week: 37.3, value: 2560, z: -0.842889187, p: 20 },
    {week: 37.3, value: 2900, z: 0.032889211, p: 51 },
    {week: 37.3, value: 3250, z: 0.84288924, p: 80 },
    {week: 38.0, value: 2670, z: -0.843010184, p: 20 },
    {week: 38.0, value: 3020, z: 0.023010207, p: 51 },
    {week: 38.0, value: 3370, z: 0.803010235, p: 79 },
    {week: 38.3, value: 2750, z: -0.843099182, p: 20 },
    {week: 38.3, value: 3110, z: 0.033099205, p: 51 },
    {week: 38.3, value: 3490, z: 0.843099233, p: 80 },
    {week: 39.0, value: 2850, z: -0.853216179, p: 20 },
    {week: 39.0, value: 3230, z: 0.033216201, p: 51 },
    {week: 39.0, value: 3800, z: 1.18321624, p: 88 },
    {week: 39.3, value: 2930, z: -0.843303177, p: 20 },
    {week: 39.3, value: 3290, z: -0.033303197, p: 49 },
    {week: 39.3, value: 3850, z: 1.083303231, p: 86 },
    {week: 40.0, value: 3030, z: -0.843417175, p: 20 },
    {week: 40.0, value: 3430, z: 0.033417196, p: 51 },
    {week: 40.0, value: 4010, z: 1.123417225, p: 87 },
    {week: 40.3, value: 3090, z: -0.883501174, p: 19 },
    {week: 40.3, value: 3510, z: 0.023501194, p: 51 },
    {week: 40.3, value: 3870, z: 0.70350121, p: 76 },
    {week: 41.0, value: 3190, z: -0.883612173, p: 19 },
    {week: 41.0, value: 3640, z: 0.053612192, p: 52 },
    {week: 41.0, value: 4240, z: 1.133612215, p: 87 },
    {week: 41.3, value: 3280, z: -0.843694174, p: 20 },
    {week: 41.3, value: 3710, z: 0.03369419, p: 51 },
    {week: 41.3, value: 4300, z: 1.08369421, p: 86 },
    {week: 42.0, value: 3380, z: -0.843803173, p: 20 },
    {week: 42.0, value: 3830, z: 0.053803189, p: 52 },
    {week: 42.0, value: 4510, z: 1.223803209, p: 89 },
    {week: 42.3, value: 3490, z: -0.773884174, p: 22 },
    {week: 42.3, value: 3910, z: 0.053884188, p: 52 },
    {week: 42.3, value: 4460, z: 1.003884203, p: 84 },
    {week: 43.0, value: 3570, z: -0.813991173, p: 21 },
    {week: 43.0, value: 3980, z: -0.023991185, p: 49 },
    {week: 43.0, value: 4480, z: 0.843991198, p: 80 },
    {week: 43.3, value: 3610, z: -0.884071171, p: 19 },
    {week: 43.3, value: 4100, z: 0.054071185, p: 52 },
    {week: 43.3, value: 4610, z: 0.914071198, p: 82 },
    {week: 44.0, value: 3780, z: -0.744177173, p: 23 },
    {week: 44.0, value: 4190, z: 0.024177184, p: 51 },
    {week: 44.0, value: 4830, z: 1.0841772, p: 86 },
    {week: 44.3, value: 3800, z: -0.84425617, p: 20 },
    {week: 44.3, value: 4270, z: 0.034256184, p: 51 },
    {week: 44.3, value: 4620, z: 0.614256193, p: 73 },
    {week: 45.0, value: 3970, z: -0.704360171, p: 24 },
    {week: 45.0, value: 4390, z: 0.054360184, p: 52 },
    {week: 45.0, value: 4900, z: 0.884360198, p: 81 },
    {week: 45.3, value: 4060, z: -0.674439171, p: 25 },
    {week: 45.3, value: 4470, z: 0.054439184, p: 52 },
    {week: 45.3, value: 5060, z: 1.004439201, p: 84 },
    {week: 46.0, value: 4140, z: -0.71454317, p: 24 },
    {week: 46.0, value: 4590, z: 0.084543184, p: 53 },
    {week: 46.0, value: 5140, z: 0.944543201, p: 83 },
    {week: 46.3, value: 4230, z: -0.68462217, p: 25 },
    {week: 46.3, value: 4700, z: 0.134622185, p: 55 },
    {week: 46.3, value: 5290, z: 1.044622204, p: 85 },
    {week: 47.0, value: 4380, z: -0.584726171, p: 28 },
    {week: 47.0, value: 4790, z: 0.104726185, p: 54 },
    {week: 47.0, value: 5350, z: 0.964726203, p: 83 },
    {week: 47.3, value: 4400, z: -0.674804168, p: 25 },
    {week: 47.3, value: 4820, z: 0.034804183, p: 51 },
    {week: 47.3, value: 5490, z: 1.034804205, p: 85 },
    {week: 48.0, value: 4290, z: -1.03490916, p: 15 },
    {week: 48.0, value: 4990, z: 0.134909185, p: 55 },
    {week: 48.0, value: 5640, z: 1.084909207, p: 86 },
    {week: 48.3, value: 4470, z: -0.844987164, p: 20 },
    {week: 48.3, value: 5020, z: 0.054987183, p: 52 },
    {week: 48.3, value: 5670, z: 1.004987206, p: 84 },
    {week: 49.0, value: 4520, z: -0.925091162, p: 18 },
    {week: 49.0, value: 5140, z: 0.075091184, p: 53 },
    {week: 49.0, value: 5670, z: 0.845091202, p: 80 },
    {week: 49.3, value: 4590, z: -0.915169162, p: 18 },
    {week: 49.3, value: 5220, z: 0.085169184, p: 53 },
    {week: 49.3, value: 6010, z: 1.185169211, p: 88 },
    {week: 50.0, value: 4870, z: -0.615273169, p: 27 },
    {week: 50.0, value: 5360, z: 0.135273185, p: 55 },
    {week: 50.0, value: 6020, z: 1.035273207, p: 85 }
  ]